/*
 * SOYGlow Skin Analyzer Data
 * Version: 1.2.0
 * Fuente: SOYGlow_Knowledge_Base_corregida_v2.xlsx
 *
 * Cargar antes de skin-analyzer.js.
 */
(function (window) {
  'use strict';

  const data = {
  "meta": {
    "name": "SOYGlow Skin Analyzer Data",
    "version": "1.2.0",
    "generatedFrom": "SOYGlow_Knowledge_Base_corregida_v2(1).xlsx",
    "language": "es",
    "counts": {
      "products": 37,
      "ingredients": 83,
      "relations": 115,
      "problems": 12,
      "skinTypes": 7,
      "objectives": 15,
      "variants": 37
    }
  },
  "config": {
    "stepOrder": [
      "Desmaquillantes",
      "Limpieza",
      "Exfoliantes",
      "Tónicos",
      "Mascarilla",
      "Serums",
      "Contorno de ojos",
      "Cremas",
      "Protector Solar"
    ],
    "labels": {
      "skinTypes": {
        "grasa": "Piel grasa",
        "mixta": "Piel mixta",
        "normal": "Piel normal",
        "seca": "Piel seca",
        "deshidratada": "Piel deshidratada"
      },
      "goals": {
        "glow": "Glow (luminosidad)",
        "hidratacion": "Hidratación",
        "antiedad_firmeza": "Antiedad / Firmeza",
        "control_grasa": "Control de grasa",
        "calmar": "Calmar"
      }
    }
  },
  "catalog": {
    "products": [
      {
        "id": "P001",
        "step": "Desmaquillantes",
        "url": "https://www.soyglow.es/products/1011-995-multiacids-papaya-cleansing-balm",
        "handle": "1011-995-multiacids-papaya-cleansing-balm",
        "name": "Multiacids & Papaya Cleansing Balm",
        "brand": "Ondo",
        "description": "Bálsamo limpiador formulado con aceites de origen botánico que ayuda a elimin...",
        "usage": "Con la ayuda de la espátula, retira una pequeña cantidad de bálsamo y fúndelo...",
        "keyIngredientsText": "Gluconolactone, Glycolic Acid, Carica Papaya Fruit Extract, Citrus Junos Frui...",
        "texture": "Bálsamo",
        "ingredients": [
          {
            "id": "I020",
            "key": "acido_glicolico",
            "name": "Ácido Glicólico",
            "originalName": "Glycolic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Renovación celular",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I022",
            "key": "gluconolactona",
            "name": "Gluconolactona",
            "originalName": "Gluconolactone",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante para piel sensible",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I044",
            "key": "yuzu",
            "name": "Yuzu",
            "originalName": "Citrus Junos Fruit Extract",
            "weight": 4.0,
            "principal": false,
            "role": "Iluminador",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I045",
            "key": "papaya",
            "name": "Papaya",
            "originalName": "Carica Papaya Fruit Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante enzimático",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I047",
            "key": "espino_amarillo",
            "name": "Espino Amarillo",
            "originalName": "Hippophae Rhamnoides Oil",
            "weight": 4.0,
            "principal": false,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56587724521803
      },
      {
        "id": "P002",
        "step": "Desmaquillantes",
        "url": "https://www.soyglow.es/products/vitamin_e-raser_cleansing_oil",
        "handle": "vitamin_e-raser_cleansing_oil",
        "name": "VITAMIN E-RASER CLEANSING OIL",
        "brand": "MEISANI",
        "description": "Aceite limpiador ligero formulado con aceites de origen botánico.",
        "usage": "Extiéndelo en las manos y masajea el producto sobre el rostro seco. Emulsióna...",
        "keyIngredientsText": ">79.0% Blend of Botanical Oils: Rice Bran, Baobab, Olive. MCT Oil, Vitamin E,...",
        "texture": "Aceite",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I052",
            "key": "aceite_de_oliva",
            "name": "Aceite de Oliva",
            "originalName": "Olive",
            "weight": 4.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Humectante",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I053",
            "key": "aceite_de_salvado_de_arroz",
            "name": "Aceite de Salvado de Arroz",
            "originalName": "Rice Bran",
            "weight": 5.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I054",
            "key": "aceite_de_baobab",
            "name": "Aceite de Baobab",
            "originalName": "Baobab",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I055",
            "key": "aceite_mct",
            "name": "Aceite MCT",
            "originalName": "MCT Oil",
            "weight": 4.0,
            "principal": false,
            "role": "Vehículo hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I056",
            "key": "calendula",
            "name": "Caléndula",
            "originalName": "Calendula Extract",
            "weight": 3.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56672172704075
      },
      {
        "id": "P003",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/deep-green-tea-cleansing-foam",
        "handle": "deep-green-tea-cleansing-foam",
        "name": "DEEP GREEN TEA CLEANSING FOAM",
        "brand": "Benton",
        "description": "Espuma limpiadora suave con té verde que ayuda a limpiar las impurezas y el m...",
        "usage": "Aplicar una cantidad adecuada sobre el rostro húmedo, hacer espuma y aclarar ...",
        "keyIngredientsText": "Camellia Leaf, Camellia Oil",
        "texture": "Espuma",
        "ingredients": [
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Leaf",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I043",
            "key": "camellia_japonica",
            "name": "Camellia Japonica",
            "originalName": "Camellia Oil",
            "weight": 4.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56672629293387
      },
      {
        "id": "P004",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/all-bright-honey-and-vitamin-c-foam-cleanser",
        "handle": "all-bright-honey-and-vitamin-c-foam-cleanser",
        "name": "All Bright Honey And Vitamin C Foam Cleanser",
        "brand": "JKOSMEC",
        "description": "Limpiador de la línea All Bright de JKosmec formulado con vitamina C y miel p...",
        "usage": "Tras el uso de un limpiador en base aceite, aplicar la espuma sobre el rostro...",
        "keyIngredientsText": "Honey Extract 0,001%, Ascorbic Acid 0,001%, Multi EX BSASM Plus 0,01%",
        "texture": "Crema espumosa",
        "ingredients": [
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I036",
            "key": "miel",
            "name": "Miel",
            "originalName": "Honey Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56673230094667
      },
      {
        "id": "P005",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/all-bright-snail-and-hyaluron-foam-cleanser",
        "handle": "all-bright-snail-and-hyaluron-foam-cleanser",
        "name": "ALL BRIGHT SNAIL AND HYALURON FOAM CLEANSER",
        "brand": "JKOSMEC",
        "description": "Limpiador suave para pieles sensibles y/o maduras con mucina de caracol y áci...",
        "usage": "Tras el uso de un limpiador en base aceite, aplicar la espuma sobre el rostro...",
        "keyIngredientsText": "Vitamin E Acetate 0,1%, Snail Secretion Filtrate 0,0015%, Multi EX BSASM Plus...",
        "texture": "Crema espumosa",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E Acetate",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Secretion Filtrate",
            "weight": 4.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56673758282059
      },
      {
        "id": "P006",
        "step": "Exfoliantes",
        "url": "https://www.soyglow.es/products/all-bright-green-tea-and-bha-peeling-gel",
        "handle": "all-bright-green-tea-and-bha-peeling-gel",
        "name": "ALL BRIGHT GREEN TEA AND BHA PEELING GEL",
        "brand": "JKOSMEC",
        "description": "Gel exfoliante de la línea All Bright de JKosmec formulado con BHA y extracto...",
        "usage": "Tras la doble limpieza de la piel, secarla con la ayuda de una toalla mediant...",
        "keyIngredientsText": "BHA, extractos de té verde.",
        "texture": "Gel",
        "ingredients": [
          {
            "id": "I019",
            "key": "acido_salicilico",
            "name": "Ácido Salicílico",
            "originalName": "BHA",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante químico",
            "benefit": "Seborregulador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Extractos de té verde",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747485659467
      },
      {
        "id": "P007",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/deep-green-tea-toner",
        "handle": "deep-green-tea-toner",
        "name": "DEEP GREEN TEA TONER",
        "brand": "Benton",
        "description": "Este tónico hidrata, calma y refresca la piel, dejándola sana y limpia.",
        "usage": "Después de limpiar el rostro, verter un poco de producto sobre un disco de al...",
        "keyIngredientsText": "50% Green Tea (Leaf, Seed and Root Extract), Hyaluronic AcidPrincipio del for...",
        "texture": "Líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea (Leaf, Seed and Root Extract)",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747544543563
      },
      {
        "id": "P008",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/glutathione-niacinamide-facial-toner",
        "handle": "glutathione-niacinamide-facial-toner",
        "name": "Glutathione Niacinamide Facial Toner",
        "brand": "APLB",
        "description": "Tónico facial con glutatión, niacinamida y centella asiática que hidrata, cal...",
        "usage": "Aplicar una cantidad moderada sobre un algodón y deslizar suavemente por el r...",
        "keyIngredientsText": "Glutathione(1, 000ppm), Niacinamide(20, 000ppm), Centella Asiatica Leaf Water...",
        "texture": "Líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Leaf Water",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021391569227
      },
      {
        "id": "P009",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/glutathione_niacinamide_toner_pad",
        "handle": "glutathione_niacinamide_toner_pad",
        "name": "GLUTATHIONE NIACINAMIDE TONER PAD",
        "brand": "APLB",
        "description": "Pads faciales con glutatión, niacinamida y centella asiática que hidratan, ca...",
        "usage": "Después de la limpieza, deslizar suavemente un pad por todo el rostro, evitan...",
        "keyIngredientsText": "Glutathione(1,000ppm), Niacinamide(1,000ppm), Centella Asiatica Leaf Water(16...",
        "texture": "Líquido con PADS",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Leaf Water",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747378835787
      },
      {
        "id": "P010",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/avocado-intensive-essence-mask",
        "handle": "avocado-intensive-essence-mask",
        "name": "AVOCADO INTENSIVE ESSENCE MASK",
        "brand": "Jkosmec",
        "description": "Mascarilla de tejido con extracto de aguacate para hidratar y nutrir la piel ...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Persea Gratissima (Avocado) Fruit Extract 0,003%, Arginine 0,05%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I082",
            "key": "aguacate",
            "name": "Aguacate",
            "originalName": "Persea Gratissima (Avocado) Fruit Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Nutritivo y emoliente",
            "benefit": "Hidratación",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I083",
            "key": "arginina",
            "name": "Arginina",
            "originalName": "Arginine",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante y acondicionador",
            "benefit": "Hidratación",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747710841163
      },
      {
        "id": "P011",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-hyaluron-mask",
        "handle": "skin-solution-hyaluron-mask",
        "name": "SKIN SOLUTION HYALURON MASK",
        "brand": "Jkosmec",
        "description": "Mascarilla de tejido con Ácido Hialurónico para aportar una hidratación inten...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Betaine 0,5%, Multi EX BSASM Plus 0,01%Principio del formulario",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748878594379
      },
      {
        "id": "P012",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/the-clean-vegan-mask-vitamin-c",
        "handle": "the-clean-vegan-mask-vitamin-c",
        "name": "The Clean Vegan Mask - Vitamin C",
        "brand": "Barulab",
        "description": "Mascarilla de tejido con Vitamina C para una piel hidratada e iluminada.",
        "usage": "Tras preparar la piel con la limpieza y tonificación, aplicar la mascarilla e...",
        "keyIngredientsText": "Niacinamide 2%Principio del formulario",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021318070603
      },
      {
        "id": "P013",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-vitamin-c-mask",
        "handle": "skin-solution-vitamin-c-mask",
        "name": "SKIN SOLUTION VITAMIN C MASK",
        "brand": "JKOSMEC",
        "description": "Mascarilla de tejido con Vitamina C para una piel más iluminada reduciendo la...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Ascorbic Acid 0,025%, Betaine 0,5%, Multi EX BSASM Plus 0,01%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748922765643
      },
      {
        "id": "P014",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-collagen-mask",
        "handle": "skin-solution-collagen-mask",
        "name": "SKIN SOLUTION COLLAGEN MASK",
        "brand": "JKOSMEC",
        "description": "Mascarilla de tejido con colágeno hidrolizado para mejorar la firmeza y elast...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Betaine 0,5%, Multi EX BSASM Plus 0,01%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748895142219
      },
      {
        "id": "P015",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/2-pieces-caffeine-green-tea-antioxidant-eye-p...",
        "handle": "2-pieces-caffeine-green-tea-antioxidant-eye-p...",
        "name": "2 Pieces - Caffeine & Green Tea Antioxidant Eye Patches",
        "brand": "Ondo",
        "description": "Parches de hidrogel para el contorno de ojos con cafeína y té verde reducen l...",
        "usage": "Aplicar sobre la piel limpia. Retíralos después de 20-30 minutos y da toqueci...",
        "keyIngredientsText": "5% Green Tea, 2% Niacinamide, 1% Caffeine.",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I025",
            "key": "cafeina",
            "name": "Cafeína",
            "originalName": "Caffeine",
            "weight": 5.0,
            "principal": true,
            "role": "Descongestionante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747938152779
      },
      {
        "id": "P016",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-collagen-eye-zone-mask",
        "handle": "skin-solution-collagen-eye-zone-mask",
        "name": "SKIN SOLUTION COLLAGEN EYE ZONE MASK",
        "brand": "JKOSMEC",
        "description": "Parches para el contorno de los ojos formulados con colágeno. Ideales para nu...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar un parche sobre la ...",
        "keyIngredientsText": "Hydrolyzed Collagen 0,002%, Beta-Glucan 0,001%, Rosa Centifolia Flower Water ...",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "Beta-Glucan",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I009",
            "key": "alantoina",
            "name": "Alantoína",
            "originalName": "Allantoin",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopheryl Acetate",
            "weight": 3.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I018",
            "key": "alfa_arbutina",
            "name": "Alfa-Arbutina",
            "originalName": "Arbutin",
            "weight": 3.0,
            "principal": false,
            "role": "Despigmentante",
            "benefit": "Manchas",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Hydrolyzed Collagen",
            "weight": 5.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Sinensis Leaf Extract",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I045",
            "key": "papaya",
            "name": "Papaya",
            "originalName": "Carica Papaya Fruit Extract",
            "weight": 3.0,
            "principal": false,
            "role": "Exfoliante enzimático",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747795677515
      },
      {
        "id": "P017",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/self-aesthetic-rose-hydrogel-lip-patch",
        "handle": "self-aesthetic-rose-hydrogel-lip-patch",
        "name": "Self Aesthetic Rose Hydrogel Lip Patch",
        "brand": "G9 Skin",
        "description": "Este parche para labios contiene agua de rosas, ácido hialurónico y colágeno.",
        "usage": "Para hidratar los labios. Saca el parche labial y aplícalo en sus labios. Déj...",
        "keyIngredientsText": "Rose Flower Water, Hyaluronic Acid, Collagen, Adenosine, Panthenol, Niacinamide",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": false,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Collagen",
            "weight": 5.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747829559627
      },
      {
        "id": "P018",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/deep-green-tea-serum",
        "handle": "deep-green-tea-serum",
        "name": "DEEP GREEN TEA SERUM",
        "brand": "Benton",
        "description": "Sérum suave con un PH ligeramente ácido, formulado con alto contenido de té v...",
        "usage": "Aplicar una cantidad adecuada uniformemente sobre la piel limpia.",
        "keyIngredientsText": "53% Green Tea, Hyaluronic Acid, PanthenolPrincipio del formulario",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748102615371
      },
      {
        "id": "P019",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/hyaluronic-squalane-serum",
        "handle": "hyaluronic-squalane-serum",
        "name": "HYALURONIC SQUALANE SERUM",
        "brand": "ONE THING",
        "description": "Sérum facial bifásico con 8 tipos de ácido hialurónico y escualano vegetal.",
        "usage": "Agitar bien antes de usar para mezclar las fases acuosa y oleosa. Aplicar sob...",
        "keyIngredientsText": "Multi-layered hyaluronic acid (8 types), plant-based squalane",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Multi-layered hyaluronic acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Plant-based squalane",
            "weight": 5.0,
            "principal": true,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748091834699
      },
      {
        "id": "P020",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/skin-solution-brightening-serum-vitamin-c",
        "handle": "skin-solution-brightening-serum-vitamin-c",
        "name": "Skin Solution Brightening Serum (vitamin C)",
        "brand": "JKOSMEC",
        "description": "Sérum iluminador con Vitamina C, Adenosina y Niacinamida para una piel más iluminada, con un mejor tono y mayor elasticidad.",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la cantidad deseada de producto sobre la piel del rostro y masajear suavemente con las yemas de los dedos hasta su completa absorción. Puede utilizarse tanto en la rutina de día como en la de noche y de forma diaria.",
        "keyIngredientsText": "Niacinamide 2%, Adenosine 0, 04%, MULTIVITASOME 0, 01%, Tranexamic Acid 0, 01%, 3-O-Ethyl Ascorbic Acid 0, 05%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "3-O-Ethyl Ascorbic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Equivalencia derivado de vitamina C; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I017",
            "key": "acido_tranexamico",
            "name": "Ácido Tranexámico",
            "originalName": "Tranexamic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Despigmentante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747975541067
      },
      {
        "id": "P021",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/skin-solution-firming-serum-collagen",
        "handle": "skin-solution-firming-serum-collagen",
        "name": "SKIN SOLUTION FIRMING SERUM (COLLAGEN)",
        "brand": "JKOSMEC",
        "description": "Sérum con colágeno, Niacinamida y Adenosina, para una piel más elástica y con más firmeza.",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la cantidad deseada de producto sobre la piel del rostro y masajear suavemente con las yemas de los dedos hasta su completa absorción. Puede utilizarse tanto en la rutina de día como en la de noche y de forma diaria.",
        "keyIngredientsText": "Niacinamide 2%, Adenosine 0,04%, ATA Collagen 3 Complex 0,01%, BS-HA 7 Complex (Hyaluronic) 0,01%, Eternal P Complex 0,01%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "BS-HA 7 Complex (Hyaluronic)",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Eternal P Complex",
            "weight": 3.0,
            "principal": false,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia de complejo peptídico; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "ATA Collagen 3 Complex",
            "weight": 4.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748072141131
      },
      {
        "id": "P022",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/revive-serum-ginseng-snail-mucin",
        "handle": "revive-serum-ginseng-snail-mucin",
        "name": "Revive Serum: Ginseng + Snail Mucin",
        "brand": "Beauty of Joseon",
        "description": "Sérum regenerador con ginseng y mucina de caracol",
        "usage": "Aplicar 2-3 gotas del sérum en el rostro sin llegar a tocar el gotero. Extender suavemente sobre la piel y dar toques para ayudar a su absorción.",
        "keyIngredientsText": "Ginseng root water 63%, Snail mucin 3%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I039",
            "key": "ginseng",
            "name": "Ginseng",
            "originalName": "Ginseng root water",
            "weight": 5.0,
            "principal": true,
            "role": "Antiedad",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail mucin",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57301534310731
      },
      {
        "id": "P023",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/the-niacinamide-15-serum",
        "handle": "the-niacinamide-15-serum",
        "name": "The Niacinamide 15 Serum",
        "brand": "COSRX",
        "description": "Este serum con niacinamida trata el acné y regula el sebo de la piel.",
        "usage": "Aplicar un par de gotas en la piel. Con la ayuda de las yemas de los dedos, masajear suavemente hasta su completa absorción desde el centro del rostro hacia el exterior.",
        "keyIngredientsText": "Niacinamida, N-acetylglucosamine, Zinc PCA, Allantoin",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamida",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I009",
            "key": "alantoina",
            "name": "Alantoína",
            "originalName": "Allantoin",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I064",
            "key": "zinc_pca",
            "name": "Zinc PCA",
            "originalName": "Zinc PCA",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Seborregulador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302020096331
      },
      {
        "id": "P024",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/glow-drops-vitamin-c-serum",
        "handle": "glow-drops-vitamin-c-serum",
        "name": "Glow Drops Vitamin C Serum",
        "brand": "Meisani",
        "description": "Sérum antioxidante ligero con Vitamina C pura que previene los signos del envejecimiento, potenciando la luminosidad del rostro.",
        "usage": "Aplicar unas gotas sobre la piel limpia y seca del rostro y masajear hasta que las capsulas de vitamina C se fundan en la piel por completo. Una vez absorbidas, puedes pasar a aplicar una crema hidratante. Utilizar preferentemente de día y en combinación con un SPF para beneficiarse plenamente de la protección antioxidante de la vitamina C. No obstante, también se puede utilizar por la noche. Principio del formulario Final del formulario",
        "keyIngredientsText": "Yuzu Water 56.0%, L-Ascorbic Acid (Vitamin C) 10.0%, Hyaluronic Acid 2.0%, Guava, Kakadu Plum, Sea Buckthorn, Green Tea Extracts, Vitamin E, Ferulic Acid.",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "L-Ascorbic Acid (Vitamin C)",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I024",
            "key": "acido_ferulico",
            "name": "Ácido Ferúlico",
            "originalName": "Ferulic Acid",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea Extracts",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I044",
            "key": "yuzu",
            "name": "Yuzu",
            "originalName": "Yuzu Water",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Glow",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I047",
            "key": "espino_amarillo",
            "name": "Espino Amarillo",
            "originalName": "Sea Buckthorn",
            "weight": 4.0,
            "principal": false,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57614720762187
      },
      {
        "id": "P025",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/hydro-boost-eye-cream",
        "handle": "hydro-boost-eye-cream",
        "name": "HYDRO BOOST EYE CREAM",
        "brand": "VILLAGE 11 FACTORY",
        "description": "Crema para el contorno de ojos con 8 tipos de ácido hialurónico y extractos naturales. Tiene una textura rica y deja la zona hidratada por un periodo largo de tiempo.",
        "usage": "Aplicar aproximadamente la cantidad de producto equivalente a la medida de un guisante (a dividir entre los dos ojos) en la zona del contorno de los ojos. Con la ayuda del dedo anular y mediante suaves toquecitos, repartir el producto por la zona hasta su completa absorción.",
        "keyIngredientsText": "Village 11TM complex 11%, Shea Butter 1%, Panthenol 0.1%, Natural ingredients 92%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 5.0,
            "principal": true,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748208685387
      },
      {
        "id": "P026",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/tube-snail-repair-eye-cream-15ml",
        "handle": "tube-snail-repair-eye-cream-15ml",
        "name": "(tube) Snail Repair Eye Cream 15ml",
        "brand": "Mizon",
        "description": "Este contorno de ojos multifunción contiene un 80 % de mucina de caracol, que ayuda a reducir y prevenir la aparición de arrugas al estimular la regeneración celular.",
        "usage": "Aplicar un poquito de producto sobre el contorno de ojos y dar toquecitos hasta su total absorción.",
        "keyIngredientsText": "Snail Mucin Extract, EGF, Adenosine, Peptide, Niacinamide, Birch Tree Sap, Squalane, Sweet Almond",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 4.0,
            "principal": false,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I030",
            "key": "egf",
            "name": "EGF",
            "originalName": "EGF",
            "weight": 5.0,
            "principal": true,
            "role": "Regeneración",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucin Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021378789707
      },
      {
        "id": "P027",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/snail-repair-eye-cream-25ml",
        "handle": "snail-repair-eye-cream-25ml",
        "name": "SNAIL REPAIR EYE CREAM 25ML",
        "brand": "Mizon",
        "description": "Este contorno de ojos multifunción contiene un 80 % de mucina de caracol, que ayuda a reducir y prevenir la aparición de arrugas al estimular la regeneración celular.",
        "usage": "Aplicar un poquito de producto sobre el contorno de ojos y dar toquecitos hasta su total absorción.",
        "keyIngredientsText": "Snail Mucin Extract, EGF, Adenosine, Peptide, Niacinamide, Birch Tree Sap, Squalane, Sweet Almond",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 4.0,
            "principal": false,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I030",
            "key": "egf",
            "name": "EGF",
            "originalName": "EGF",
            "weight": 5.0,
            "principal": true,
            "role": "Regeneración",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucin Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748142952779
      },
      {
        "id": "P028",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/centella-soothing-cream",
        "handle": "centella-soothing-cream",
        "name": "Centella Soothing Cream",
        "brand": "ONE THING",
        "description": "Esta crema Coreana de centella, calma la piel y la hidrata, absorbiéndose rápidamente y sin dejar la piel pegajosa.",
        "usage": "Puede utilizarse tanto de día como de noche. Aplicar la cantidad necesaria sobre la piel mediante movimientos circulares hasta su completa absorción. Puede también utilizarse cómo crema corporal.",
        "keyIngredientsText": "Centella Asiatica Extract, β-glucan",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "β-glucan",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021298082123
      },
      {
        "id": "P029",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/deep-green-tea-lotion",
        "handle": "deep-green-tea-lotion",
        "name": "DEEP GREEN TEA LOTION",
        "brand": "Benton",
        "description": "Esta loción hidrata, calma y refresca la piel, dejándola limpia y sana.",
        "usage": "Después de tónico y del sérum, aplicar el gel dando toques suaves sobre la piel. Si no vas a usar una crema a continuación, puedes aplicar dos capas de loción para una mayor hidratación.",
        "keyIngredientsText": "Camellia Sinensis Leaf Water, Helianthus Annuus (Sunflower) Seed Oil, EG-Green Tea (Camellia Sinensis Leaf, Seed and Root extracts), Tocopherol",
        "texture": "Loción",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopherol",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Sinensis Leaf Water / extracts",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748275827019
      },
      {
        "id": "P030",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-moisturising-face-cream-hyaluron",
        "handle": "skin-solution-moisturising-face-cream-hyaluron",
        "name": "SKIN SOLUTION MOISTURISING FACE CREAM (HYALURON)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Ácido Hialurónico, Adenosina y Niacinamida para una piel más hidratada y flexible.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 0,5%, Adenosine 0,04%, Sodium Hyaluronate 0,005%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Sodium Hyaluronate",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748225003851
      },
      {
        "id": "P031",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-brightening-face-cream-vitamin-c",
        "handle": "skin-solution-brightening-face-cream-vitamin-c",
        "name": "SKIN SOLUTION BRIGHTENING FACE CREAM (VITAMIN C)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Vitamina C, Adenosina y Niacinamida para iluminar la piel, promover la producción de colágeno y combatir los signos del envejecimiento.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 2%, Adenosine 0,04%, Ascorbic Acid 0,001%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748248334667
      },
      {
        "id": "P032",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-firming-face-cream-collagen",
        "handle": "skin-solution-firming-face-cream-collagen",
        "name": "SKIN SOLUTION FIRMING FACE CREAM (COLLAGEN)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Colágeno, Adenosina y Niacinamida para tratar los primeros signos de envejecimiento, fortaleciendo la piel y mejorando su firmeza.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 0,3%, Adenosine 0,04%, Hydrolyzed Collagen 0,01%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Hydrolyzed Collagen",
            "weight": 4.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748263014731
      },
      {
        "id": "P033",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/advanced-snail-92-all-in-one-cream",
        "handle": "advanced-snail-92-all-in-one-cream",
        "name": "Advanced Snail 92 All In One Cream",
        "brand": "COSRX",
        "description": "Esta crema hidratante contiene un 92 % de mucina de caracol, que nutre e hidrata la piel sin dejar sensación grasa.",
        "usage": "Aplicar la crema sobre el rostro, evitando el contorno de los ojos y de los labios. Dar toquecitos con los dedos hasta su total absorción.",
        "keyIngredientsText": "Snail Secretion Filtrate",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Secretion Filtrate",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57301236711755
      },
      {
        "id": "P034",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/maple-energy-infusing-cream",
        "handle": "maple-energy-infusing-cream",
        "name": "Maple Energy Infusing Cream",
        "brand": "Klairs",
        "description": "Crema hidratante y nutritiva con savia de arce que fortalece la barrera cutánea y mejora firmeza, elasticidad y luminosidad.",
        "usage": "Aplicar una pequeña cantidad sobre rostro y cuello. Extender suavemente hasta su completa absorción. Apta para uso diario, mañana y noche.",
        "keyIngredientsText": "Acer Saccharum (Sugar Maple) Sap 52.87%, Squalane, Acer Rubrum Bark Extract, Acetyl Hexapeptide-8, Palmitoyl Tripeptide-1, Palmitoyl Tetrapeptide-7, Tocopherol",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 5.0,
            "principal": true,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopherol",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Acetyl Hexapeptide-8 / Palmitoyl peptides",
            "weight": 5.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302114402635
      },
      {
        "id": "P035",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/all-in-one-snail-repair-cream-75g",
        "handle": "all-in-one-snail-repair-cream-75g",
        "name": "All In One Snail Repair Cream 75g",
        "brand": "Mizon",
        "description": "Su fórmula con 92 % mucina de caracol estimula la regeneración cutánea y previene la aparición de imperfecciones y cicatrices derivadas del acné.",
        "usage": "Aplicar por todo el rostro y el cuello, y masajear suavemente. Si se tiene le piel seca, es recomendable aplicar una crema hidratante a continuación.",
        "keyIngredientsText": "Snail Mucus, Birch Black Sap, Arnica, Gentiana, Green Tea, Raspberry, Adenosine, Centella, Sodium Hyaluronate, Peptide, Beta glucan",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella",
            "weight": 4.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Sodium Hyaluronate",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "Beta glucan",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 3.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucus",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302193111371
      },
      {
        "id": "P036",
        "step": "Protector Solar",
        "url": "https://www.soyglow.es/products/relief-sun-rice-probiotics",
        "handle": "relief-sun-rice-probiotics",
        "name": "Relief Sun: Rice + Probiotics",
        "brand": "Beauty of Joseon",
        "description": "Protector solar con textura ligera y probióticos",
        "usage": "En el último paso de la rutina de día, aplicar una cantidad generosa del protector sobre el rostro y/o cualquier otra parte expuesta al sol. Recomendamos reaplicar el protector cada dos horas.",
        "keyIngredientsText": "Rice extract 30% + Grain fermented extracts",
        "texture": "Crema ligera",
        "ingredients": [
          {
            "id": "I050",
            "key": "arroz_fermentado",
            "name": "Arroz Fermentado",
            "originalName": "Grain fermented extracts",
            "weight": 4.0,
            "principal": true,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I079",
            "key": "extracto_de_arroz",
            "name": "Extracto de Arroz",
            "originalName": "Rice extract",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57013742666059
      },
      {
        "id": "P037",
        "step": "Protector Solar",
        "url": "https://www.soyglow.es/products/matte-sun-stick-mugwort-camilia-spf-50-pa",
        "handle": "matte-sun-stick-mugwort-camilia-spf-50-pa",
        "name": "Matte Sun Stick: Mugwort + Camilia (spf 50+ Pa++++)",
        "brand": "Beauty of Joseon",
        "description": "Protector solar en stick con acabado mate",
        "usage": "Reaplicar el protector solar cada dos horas. Se puede usar el stick tanto en el rostro como en el cuerpo, procurando hacer salir del envase sólo la cantidad necesaria de producto para que se conserve mejor y dure más. Aplicar extendiéndolo con suavidad sobre la piel, sin dar tirones. En el caso de que se aplique sobre maquillaje, vigilar de no moverlo.",
        "keyIngredientsText": "Rice extract 30% + grain fermented extracts",
        "texture": "Crema en Stick",
        "ingredients": [
          {
            "id": "I050",
            "key": "arroz_fermentado",
            "name": "Arroz Fermentado",
            "originalName": "Grain fermented extracts",
            "weight": 4.0,
            "principal": true,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I079",
            "key": "extracto_de_arroz",
            "name": "Extracto de Arroz",
            "originalName": "Rice extract",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302260220235
      }
    ],
    "productsById": {
      "P001": {
        "id": "P001",
        "step": "Desmaquillantes",
        "url": "https://www.soyglow.es/products/1011-995-multiacids-papaya-cleansing-balm",
        "handle": "1011-995-multiacids-papaya-cleansing-balm",
        "name": "Multiacids & Papaya Cleansing Balm",
        "brand": "Ondo",
        "description": "Bálsamo limpiador formulado con aceites de origen botánico que ayuda a elimin...",
        "usage": "Con la ayuda de la espátula, retira una pequeña cantidad de bálsamo y fúndelo...",
        "keyIngredientsText": "Gluconolactone, Glycolic Acid, Carica Papaya Fruit Extract, Citrus Junos Frui...",
        "texture": "Bálsamo",
        "ingredients": [
          {
            "id": "I020",
            "key": "acido_glicolico",
            "name": "Ácido Glicólico",
            "originalName": "Glycolic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Renovación celular",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I022",
            "key": "gluconolactona",
            "name": "Gluconolactona",
            "originalName": "Gluconolactone",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante para piel sensible",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I044",
            "key": "yuzu",
            "name": "Yuzu",
            "originalName": "Citrus Junos Fruit Extract",
            "weight": 4.0,
            "principal": false,
            "role": "Iluminador",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I045",
            "key": "papaya",
            "name": "Papaya",
            "originalName": "Carica Papaya Fruit Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante enzimático",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I047",
            "key": "espino_amarillo",
            "name": "Espino Amarillo",
            "originalName": "Hippophae Rhamnoides Oil",
            "weight": 4.0,
            "principal": false,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56587724521803
      },
      "P002": {
        "id": "P002",
        "step": "Desmaquillantes",
        "url": "https://www.soyglow.es/products/vitamin_e-raser_cleansing_oil",
        "handle": "vitamin_e-raser_cleansing_oil",
        "name": "VITAMIN E-RASER CLEANSING OIL",
        "brand": "MEISANI",
        "description": "Aceite limpiador ligero formulado con aceites de origen botánico.",
        "usage": "Extiéndelo en las manos y masajea el producto sobre el rostro seco. Emulsióna...",
        "keyIngredientsText": ">79.0% Blend of Botanical Oils: Rice Bran, Baobab, Olive. MCT Oil, Vitamin E,...",
        "texture": "Aceite",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I052",
            "key": "aceite_de_oliva",
            "name": "Aceite de Oliva",
            "originalName": "Olive",
            "weight": 4.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Humectante",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I053",
            "key": "aceite_de_salvado_de_arroz",
            "name": "Aceite de Salvado de Arroz",
            "originalName": "Rice Bran",
            "weight": 5.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I054",
            "key": "aceite_de_baobab",
            "name": "Aceite de Baobab",
            "originalName": "Baobab",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I055",
            "key": "aceite_mct",
            "name": "Aceite MCT",
            "originalName": "MCT Oil",
            "weight": 4.0,
            "principal": false,
            "role": "Vehículo hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I056",
            "key": "calendula",
            "name": "Caléndula",
            "originalName": "Calendula Extract",
            "weight": 3.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56672172704075
      },
      "P003": {
        "id": "P003",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/deep-green-tea-cleansing-foam",
        "handle": "deep-green-tea-cleansing-foam",
        "name": "DEEP GREEN TEA CLEANSING FOAM",
        "brand": "Benton",
        "description": "Espuma limpiadora suave con té verde que ayuda a limpiar las impurezas y el m...",
        "usage": "Aplicar una cantidad adecuada sobre el rostro húmedo, hacer espuma y aclarar ...",
        "keyIngredientsText": "Camellia Leaf, Camellia Oil",
        "texture": "Espuma",
        "ingredients": [
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Leaf",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I043",
            "key": "camellia_japonica",
            "name": "Camellia Japonica",
            "originalName": "Camellia Oil",
            "weight": 4.0,
            "principal": true,
            "role": "Nutritivo",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56672629293387
      },
      "P004": {
        "id": "P004",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/all-bright-honey-and-vitamin-c-foam-cleanser",
        "handle": "all-bright-honey-and-vitamin-c-foam-cleanser",
        "name": "All Bright Honey And Vitamin C Foam Cleanser",
        "brand": "JKOSMEC",
        "description": "Limpiador de la línea All Bright de JKosmec formulado con vitamina C y miel p...",
        "usage": "Tras el uso de un limpiador en base aceite, aplicar la espuma sobre el rostro...",
        "keyIngredientsText": "Honey Extract 0,001%, Ascorbic Acid 0,001%, Multi EX BSASM Plus 0,01%",
        "texture": "Crema espumosa",
        "ingredients": [
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I036",
            "key": "miel",
            "name": "Miel",
            "originalName": "Honey Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56673230094667
      },
      "P005": {
        "id": "P005",
        "step": "Limpieza",
        "url": "https://www.soyglow.es/products/all-bright-snail-and-hyaluron-foam-cleanser",
        "handle": "all-bright-snail-and-hyaluron-foam-cleanser",
        "name": "ALL BRIGHT SNAIL AND HYALURON FOAM CLEANSER",
        "brand": "JKOSMEC",
        "description": "Limpiador suave para pieles sensibles y/o maduras con mucina de caracol y áci...",
        "usage": "Tras el uso de un limpiador en base aceite, aplicar la espuma sobre el rostro...",
        "keyIngredientsText": "Vitamin E Acetate 0,1%, Snail Secretion Filtrate 0,0015%, Multi EX BSASM Plus...",
        "texture": "Crema espumosa",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E Acetate",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Secretion Filtrate",
            "weight": 4.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56673758282059
      },
      "P006": {
        "id": "P006",
        "step": "Exfoliantes",
        "url": "https://www.soyglow.es/products/all-bright-green-tea-and-bha-peeling-gel",
        "handle": "all-bright-green-tea-and-bha-peeling-gel",
        "name": "ALL BRIGHT GREEN TEA AND BHA PEELING GEL",
        "brand": "JKOSMEC",
        "description": "Gel exfoliante de la línea All Bright de JKosmec formulado con BHA y extracto...",
        "usage": "Tras la doble limpieza de la piel, secarla con la ayuda de una toalla mediant...",
        "keyIngredientsText": "BHA, extractos de té verde.",
        "texture": "Gel",
        "ingredients": [
          {
            "id": "I019",
            "key": "acido_salicilico",
            "name": "Ácido Salicílico",
            "originalName": "BHA",
            "weight": 5.0,
            "principal": true,
            "role": "Exfoliante químico",
            "benefit": "Seborregulador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Extractos de té verde",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747485659467
      },
      "P007": {
        "id": "P007",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/deep-green-tea-toner",
        "handle": "deep-green-tea-toner",
        "name": "DEEP GREEN TEA TONER",
        "brand": "Benton",
        "description": "Este tónico hidrata, calma y refresca la piel, dejándola sana y limpia.",
        "usage": "Después de limpiar el rostro, verter un poco de producto sobre un disco de al...",
        "keyIngredientsText": "50% Green Tea (Leaf, Seed and Root Extract), Hyaluronic AcidPrincipio del for...",
        "texture": "Líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea (Leaf, Seed and Root Extract)",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747544543563
      },
      "P008": {
        "id": "P008",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/glutathione-niacinamide-facial-toner",
        "handle": "glutathione-niacinamide-facial-toner",
        "name": "Glutathione Niacinamide Facial Toner",
        "brand": "APLB",
        "description": "Tónico facial con glutatión, niacinamida y centella asiática que hidrata, cal...",
        "usage": "Aplicar una cantidad moderada sobre un algodón y deslizar suavemente por el r...",
        "keyIngredientsText": "Glutathione(1, 000ppm), Niacinamide(20, 000ppm), Centella Asiatica Leaf Water...",
        "texture": "Líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Leaf Water",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021391569227
      },
      "P009": {
        "id": "P009",
        "step": "Tónicos",
        "url": "https://www.soyglow.es/products/glutathione_niacinamide_toner_pad",
        "handle": "glutathione_niacinamide_toner_pad",
        "name": "GLUTATHIONE NIACINAMIDE TONER PAD",
        "brand": "APLB",
        "description": "Pads faciales con glutatión, niacinamida y centella asiática que hidratan, ca...",
        "usage": "Después de la limpieza, deslizar suavemente un pad por todo el rostro, evitan...",
        "keyIngredientsText": "Glutathione(1,000ppm), Niacinamide(1,000ppm), Centella Asiatica Leaf Water(16...",
        "texture": "Líquido con PADS",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Leaf Water",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747378835787
      },
      "P010": {
        "id": "P010",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/avocado-intensive-essence-mask",
        "handle": "avocado-intensive-essence-mask",
        "name": "AVOCADO INTENSIVE ESSENCE MASK",
        "brand": "Jkosmec",
        "description": "Mascarilla de tejido con extracto de aguacate para hidratar y nutrir la piel ...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Persea Gratissima (Avocado) Fruit Extract 0,003%, Arginine 0,05%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I082",
            "key": "aguacate",
            "name": "Aguacate",
            "originalName": "Persea Gratissima (Avocado) Fruit Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Nutritivo y emoliente",
            "benefit": "Hidratación",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I083",
            "key": "arginina",
            "name": "Arginina",
            "originalName": "Arginine",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante y acondicionador",
            "benefit": "Hidratación",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747710841163
      },
      "P011": {
        "id": "P011",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-hyaluron-mask",
        "handle": "skin-solution-hyaluron-mask",
        "name": "SKIN SOLUTION HYALURON MASK",
        "brand": "Jkosmec",
        "description": "Mascarilla de tejido con Ácido Hialurónico para aportar una hidratación inten...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Betaine 0,5%, Multi EX BSASM Plus 0,01%Principio del formulario",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748878594379
      },
      "P012": {
        "id": "P012",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/the-clean-vegan-mask-vitamin-c",
        "handle": "the-clean-vegan-mask-vitamin-c",
        "name": "The Clean Vegan Mask - Vitamin C",
        "brand": "Barulab",
        "description": "Mascarilla de tejido con Vitamina C para una piel hidratada e iluminada.",
        "usage": "Tras preparar la piel con la limpieza y tonificación, aplicar la mascarilla e...",
        "keyIngredientsText": "Niacinamide 2%Principio del formulario",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021318070603
      },
      "P013": {
        "id": "P013",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-vitamin-c-mask",
        "handle": "skin-solution-vitamin-c-mask",
        "name": "SKIN SOLUTION VITAMIN C MASK",
        "brand": "JKOSMEC",
        "description": "Mascarilla de tejido con Vitamina C para una piel más iluminada reduciendo la...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Ascorbic Acid 0,025%, Betaine 0,5%, Multi EX BSASM Plus 0,01%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748922765643
      },
      "P014": {
        "id": "P014",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-collagen-mask",
        "handle": "skin-solution-collagen-mask",
        "name": "SKIN SOLUTION COLLAGEN MASK",
        "brand": "JKOSMEC",
        "description": "Mascarilla de tejido con colágeno hidrolizado para mejorar la firmeza y elast...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la mascarilla ajust...",
        "keyIngredientsText": "Betaine 0,5%, Multi EX BSASM Plus 0,01%",
        "texture": "Mascarilla de tejido",
        "ingredients": [
          {
            "id": "I069",
            "key": "betaina",
            "name": "Betaína",
            "originalName": "Betaine",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748895142219
      },
      "P015": {
        "id": "P015",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/2-pieces-caffeine-green-tea-antioxidant-eye-p...",
        "handle": "2-pieces-caffeine-green-tea-antioxidant-eye-p...",
        "name": "2 Pieces - Caffeine & Green Tea Antioxidant Eye Patches",
        "brand": "Ondo",
        "description": "Parches de hidrogel para el contorno de ojos con cafeína y té verde reducen l...",
        "usage": "Aplicar sobre la piel limpia. Retíralos después de 20-30 minutos y da toqueci...",
        "keyIngredientsText": "5% Green Tea, 2% Niacinamide, 1% Caffeine.",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I025",
            "key": "cafeina",
            "name": "Cafeína",
            "originalName": "Caffeine",
            "weight": 5.0,
            "principal": true,
            "role": "Descongestionante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747938152779
      },
      "P016": {
        "id": "P016",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/skin-solution-collagen-eye-zone-mask",
        "handle": "skin-solution-collagen-eye-zone-mask",
        "name": "SKIN SOLUTION COLLAGEN EYE ZONE MASK",
        "brand": "JKOSMEC",
        "description": "Parches para el contorno de los ojos formulados con colágeno. Ideales para nu...",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar un parche sobre la ...",
        "keyIngredientsText": "Hydrolyzed Collagen 0,002%, Beta-Glucan 0,001%, Rosa Centifolia Flower Water ...",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "Beta-Glucan",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I009",
            "key": "alantoina",
            "name": "Alantoína",
            "originalName": "Allantoin",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopheryl Acetate",
            "weight": 3.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I018",
            "key": "alfa_arbutina",
            "name": "Alfa-Arbutina",
            "originalName": "Arbutin",
            "weight": 3.0,
            "principal": false,
            "role": "Despigmentante",
            "benefit": "Manchas",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Hydrolyzed Collagen",
            "weight": 5.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Sinensis Leaf Extract",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I045",
            "key": "papaya",
            "name": "Papaya",
            "originalName": "Carica Papaya Fruit Extract",
            "weight": 3.0,
            "principal": false,
            "role": "Exfoliante enzimático",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747795677515
      },
      "P017": {
        "id": "P017",
        "step": "Mascarilla",
        "url": "https://www.soyglow.es/products/self-aesthetic-rose-hydrogel-lip-patch",
        "handle": "self-aesthetic-rose-hydrogel-lip-patch",
        "name": "Self Aesthetic Rose Hydrogel Lip Patch",
        "brand": "G9 Skin",
        "description": "Este parche para labios contiene agua de rosas, ácido hialurónico y colágeno.",
        "usage": "Para hidratar los labios. Saca el parche labial y aplícalo en sus labios. Déj...",
        "keyIngredientsText": "Rose Flower Water, Hyaluronic Acid, Collagen, Adenosine, Panthenol, Niacinamide",
        "texture": "Parches de hidrogel",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": false,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Collagen",
            "weight": 5.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747829559627
      },
      "P018": {
        "id": "P018",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/deep-green-tea-serum",
        "handle": "deep-green-tea-serum",
        "name": "DEEP GREEN TEA SERUM",
        "brand": "Benton",
        "description": "Sérum suave con un PH ligeramente ácido, formulado con alto contenido de té v...",
        "usage": "Aplicar una cantidad adecuada uniformemente sobre la piel limpia.",
        "keyIngredientsText": "53% Green Tea, Hyaluronic Acid, PanthenolPrincipio del formulario",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748102615371
      },
      "P019": {
        "id": "P019",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/hyaluronic-squalane-serum",
        "handle": "hyaluronic-squalane-serum",
        "name": "HYALURONIC SQUALANE SERUM",
        "brand": "ONE THING",
        "description": "Sérum facial bifásico con 8 tipos de ácido hialurónico y escualano vegetal.",
        "usage": "Agitar bien antes de usar para mezclar las fases acuosa y oleosa. Aplicar sob...",
        "keyIngredientsText": "Multi-layered hyaluronic acid (8 types), plant-based squalane",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Multi-layered hyaluronic acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Plant-based squalane",
            "weight": 5.0,
            "principal": true,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748091834699
      },
      "P020": {
        "id": "P020",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/skin-solution-brightening-serum-vitamin-c",
        "handle": "skin-solution-brightening-serum-vitamin-c",
        "name": "Skin Solution Brightening Serum (vitamin C)",
        "brand": "JKOSMEC",
        "description": "Sérum iluminador con Vitamina C, Adenosina y Niacinamida para una piel más iluminada, con un mejor tono y mayor elasticidad.",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la cantidad deseada de producto sobre la piel del rostro y masajear suavemente con las yemas de los dedos hasta su completa absorción. Puede utilizarse tanto en la rutina de día como en la de noche y de forma diaria.",
        "keyIngredientsText": "Niacinamide 2%, Adenosine 0, 04%, MULTIVITASOME 0, 01%, Tranexamic Acid 0, 01%, 3-O-Ethyl Ascorbic Acid 0, 05%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "3-O-Ethyl Ascorbic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Equivalencia derivado de vitamina C; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I017",
            "key": "acido_tranexamico",
            "name": "Ácido Tranexámico",
            "originalName": "Tranexamic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Despigmentante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56747975541067
      },
      "P021": {
        "id": "P021",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/skin-solution-firming-serum-collagen",
        "handle": "skin-solution-firming-serum-collagen",
        "name": "SKIN SOLUTION FIRMING SERUM (COLLAGEN)",
        "brand": "JKOSMEC",
        "description": "Sérum con colágeno, Niacinamida y Adenosina, para una piel más elástica y con más firmeza.",
        "usage": "Tras la doble limpieza y tonificación de la piel, aplicar la cantidad deseada de producto sobre la piel del rostro y masajear suavemente con las yemas de los dedos hasta su completa absorción. Puede utilizarse tanto en la rutina de día como en la de noche y de forma diaria.",
        "keyIngredientsText": "Niacinamide 2%, Adenosine 0,04%, ATA Collagen 3 Complex 0,01%, BS-HA 7 Complex (Hyaluronic) 0,01%, Eternal P Complex 0,01%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "BS-HA 7 Complex (Hyaluronic)",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Eternal P Complex",
            "weight": 3.0,
            "principal": false,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia de complejo peptídico; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "ATA Collagen 3 Complex",
            "weight": 4.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748072141131
      },
      "P022": {
        "id": "P022",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/revive-serum-ginseng-snail-mucin",
        "handle": "revive-serum-ginseng-snail-mucin",
        "name": "Revive Serum: Ginseng + Snail Mucin",
        "brand": "Beauty of Joseon",
        "description": "Sérum regenerador con ginseng y mucina de caracol",
        "usage": "Aplicar 2-3 gotas del sérum en el rostro sin llegar a tocar el gotero. Extender suavemente sobre la piel y dar toques para ayudar a su absorción.",
        "keyIngredientsText": "Ginseng root water 63%, Snail mucin 3%",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I039",
            "key": "ginseng",
            "name": "Ginseng",
            "originalName": "Ginseng root water",
            "weight": 5.0,
            "principal": true,
            "role": "Antiedad",
            "benefit": "Antioxidante",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail mucin",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57301534310731
      },
      "P023": {
        "id": "P023",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/the-niacinamide-15-serum",
        "handle": "the-niacinamide-15-serum",
        "name": "The Niacinamide 15 Serum",
        "brand": "COSRX",
        "description": "Este serum con niacinamida trata el acné y regula el sebo de la piel.",
        "usage": "Aplicar un par de gotas en la piel. Con la ayuda de las yemas de los dedos, masajear suavemente hasta su completa absorción desde el centro del rostro hacia el exterior.",
        "keyIngredientsText": "Niacinamida, N-acetylglucosamine, Zinc PCA, Allantoin",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamida",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I009",
            "key": "alantoina",
            "name": "Alantoína",
            "originalName": "Allantoin",
            "weight": 4.0,
            "principal": false,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I064",
            "key": "zinc_pca",
            "name": "Zinc PCA",
            "originalName": "Zinc PCA",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Seborregulador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302020096331
      },
      "P024": {
        "id": "P024",
        "step": "Serums",
        "url": "https://www.soyglow.es/products/glow-drops-vitamin-c-serum",
        "handle": "glow-drops-vitamin-c-serum",
        "name": "Glow Drops Vitamin C Serum",
        "brand": "Meisani",
        "description": "Sérum antioxidante ligero con Vitamina C pura que previene los signos del envejecimiento, potenciando la luminosidad del rostro.",
        "usage": "Aplicar unas gotas sobre la piel limpia y seca del rostro y masajear hasta que las capsulas de vitamina C se fundan en la piel por completo. Una vez absorbidas, puedes pasar a aplicar una crema hidratante. Utilizar preferentemente de día y en combinación con un SPF para beneficiarse plenamente de la protección antioxidante de la vitamina C. No obstante, también se puede utilizar por la noche. Principio del formulario Final del formulario",
        "keyIngredientsText": "Yuzu Water 56.0%, L-Ascorbic Acid (Vitamin C) 10.0%, Hyaluronic Acid 2.0%, Guava, Kakadu Plum, Sea Buckthorn, Green Tea Extracts, Vitamin E, Ferulic Acid.",
        "texture": "Serum líquido",
        "ingredients": [
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Hyaluronic Acid",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "L-Ascorbic Acid (Vitamin C)",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Vitamin E",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I024",
            "key": "acido_ferulico",
            "name": "Ácido Ferúlico",
            "originalName": "Ferulic Acid",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea Extracts",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I044",
            "key": "yuzu",
            "name": "Yuzu",
            "originalName": "Yuzu Water",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Glow",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I047",
            "key": "espino_amarillo",
            "name": "Espino Amarillo",
            "originalName": "Sea Buckthorn",
            "weight": 4.0,
            "principal": false,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57614720762187
      },
      "P025": {
        "id": "P025",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/hydro-boost-eye-cream",
        "handle": "hydro-boost-eye-cream",
        "name": "HYDRO BOOST EYE CREAM",
        "brand": "VILLAGE 11 FACTORY",
        "description": "Crema para el contorno de ojos con 8 tipos de ácido hialurónico y extractos naturales. Tiene una textura rica y deja la zona hidratada por un periodo largo de tiempo.",
        "usage": "Aplicar aproximadamente la cantidad de producto equivalente a la medida de un guisante (a dividir entre los dos ojos) en la zona del contorno de los ojos. Con la ayuda del dedo anular y mediante suaves toquecitos, repartir el producto por la zona hasta su completa absorción.",
        "keyIngredientsText": "Village 11TM complex 11%, Shea Butter 1%, Panthenol 0.1%, Natural ingredients 92%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I005",
            "key": "pantenol",
            "name": "Pantenol",
            "originalName": "Panthenol",
            "weight": 5.0,
            "principal": true,
            "role": "Calmante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748208685387
      },
      "P026": {
        "id": "P026",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/tube-snail-repair-eye-cream-15ml",
        "handle": "tube-snail-repair-eye-cream-15ml",
        "name": "(tube) Snail Repair Eye Cream 15ml",
        "brand": "Mizon",
        "description": "Este contorno de ojos multifunción contiene un 80 % de mucina de caracol, que ayuda a reducir y prevenir la aparición de arrugas al estimular la regeneración celular.",
        "usage": "Aplicar un poquito de producto sobre el contorno de ojos y dar toquecitos hasta su total absorción.",
        "keyIngredientsText": "Snail Mucin Extract, EGF, Adenosine, Peptide, Niacinamide, Birch Tree Sap, Squalane, Sweet Almond",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 4.0,
            "principal": false,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I030",
            "key": "egf",
            "name": "EGF",
            "originalName": "EGF",
            "weight": 5.0,
            "principal": true,
            "role": "Regeneración",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucin Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021378789707
      },
      "P027": {
        "id": "P027",
        "step": "Contorno de ojos",
        "url": "https://www.soyglow.es/products/snail-repair-eye-cream-25ml",
        "handle": "snail-repair-eye-cream-25ml",
        "name": "SNAIL REPAIR EYE CREAM 25ML",
        "brand": "Mizon",
        "description": "Este contorno de ojos multifunción contiene un 80 % de mucina de caracol, que ayuda a reducir y prevenir la aparición de arrugas al estimular la regeneración celular.",
        "usage": "Aplicar un poquito de producto sobre el contorno de ojos y dar toquecitos hasta su total absorción.",
        "keyIngredientsText": "Snail Mucin Extract, EGF, Adenosine, Peptide, Niacinamide, Birch Tree Sap, Squalane, Sweet Almond",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 4.0,
            "principal": false,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 4.0,
            "principal": false,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I030",
            "key": "egf",
            "name": "EGF",
            "originalName": "EGF",
            "weight": 5.0,
            "principal": true,
            "role": "Regeneración",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucin Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748142952779
      },
      "P028": {
        "id": "P028",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/centella-soothing-cream",
        "handle": "centella-soothing-cream",
        "name": "Centella Soothing Cream",
        "brand": "ONE THING",
        "description": "Esta crema Coreana de centella, calma la piel y la hidrata, absorbiéndose rápidamente y sin dejar la piel pegajosa.",
        "usage": "Puede utilizarse tanto de día como de noche. Aplicar la cantidad necesaria sobre la piel mediante movimientos circulares hasta su completa absorción. Puede también utilizarse cómo crema corporal.",
        "keyIngredientsText": "Centella Asiatica Extract, β-glucan",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella Asiatica Extract",
            "weight": 5.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "β-glucan",
            "weight": 5.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57021298082123
      },
      "P029": {
        "id": "P029",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/deep-green-tea-lotion",
        "handle": "deep-green-tea-lotion",
        "name": "DEEP GREEN TEA LOTION",
        "brand": "Benton",
        "description": "Esta loción hidrata, calma y refresca la piel, dejándola limpia y sana.",
        "usage": "Después de tónico y del sérum, aplicar el gel dando toques suaves sobre la piel. Si no vas a usar una crema a continuación, puedes aplicar dos capas de loción para una mayor hidratación.",
        "keyIngredientsText": "Camellia Sinensis Leaf Water, Helianthus Annuus (Sunflower) Seed Oil, EG-Green Tea (Camellia Sinensis Leaf, Seed and Root extracts), Tocopherol",
        "texture": "Loción",
        "ingredients": [
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopherol",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Camellia Sinensis Leaf Water / extracts",
            "weight": 5.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748275827019
      },
      "P030": {
        "id": "P030",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-moisturising-face-cream-hyaluron",
        "handle": "skin-solution-moisturising-face-cream-hyaluron",
        "name": "SKIN SOLUTION MOISTURISING FACE CREAM (HYALURON)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Ácido Hialurónico, Adenosina y Niacinamida para una piel más hidratada y flexible.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 0,5%, Adenosine 0,04%, Sodium Hyaluronate 0,005%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Sodium Hyaluronate",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748225003851
      },
      "P031": {
        "id": "P031",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-brightening-face-cream-vitamin-c",
        "handle": "skin-solution-brightening-face-cream-vitamin-c",
        "name": "SKIN SOLUTION BRIGHTENING FACE CREAM (VITAMIN C)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Vitamina C, Adenosina y Niacinamida para iluminar la piel, promover la producción de colágeno y combatir los signos del envejecimiento.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 2%, Adenosine 0,04%, Ascorbic Acid 0,001%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I014",
            "key": "vitamina_c",
            "name": "Vitamina C",
            "originalName": "Ascorbic Acid",
            "weight": 4.0,
            "principal": true,
            "role": "Antioxidante",
            "benefit": "Manchas",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748248334667
      },
      "P032": {
        "id": "P032",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/skin-solution-firming-face-cream-collagen",
        "handle": "skin-solution-firming-face-cream-collagen",
        "name": "SKIN SOLUTION FIRMING FACE CREAM (COLLAGEN)",
        "brand": "JKOSMEC",
        "description": "Crema hidratante con Colágeno, Adenosina y Niacinamida para tratar los primeros signos de envejecimiento, fortaleciendo la piel y mejorando su firmeza.",
        "usage": "Aplicar la cantidad deseada de producto sobre la piel y masajear suavemente hasta su completa absorción. Es apta para utilizarse tanto en la rutina de mañana como en la rutina de noche.",
        "keyIngredientsText": "Niacinamide 2%, Shea Butter 0,3%, Adenosine 0,04%, Hydrolyzed Collagen 0,01%",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I001",
            "key": "niacinamida",
            "name": "Niacinamida",
            "originalName": "Niacinamide",
            "weight": 5.0,
            "principal": true,
            "role": "Seborregulador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I028",
            "key": "colageno_hidrolizado",
            "name": "Colágeno Hidrolizado",
            "originalName": "Hydrolyzed Collagen",
            "weight": 4.0,
            "principal": true,
            "role": "Hidratante",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 56748263014731
      },
      "P033": {
        "id": "P033",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/advanced-snail-92-all-in-one-cream",
        "handle": "advanced-snail-92-all-in-one-cream",
        "name": "Advanced Snail 92 All In One Cream",
        "brand": "COSRX",
        "description": "Esta crema hidratante contiene un 92 % de mucina de caracol, que nutre e hidrata la piel sin dejar sensación grasa.",
        "usage": "Aplicar la crema sobre el rostro, evitando el contorno de los ojos y de los labios. Dar toquecitos con los dedos hasta su total absorción.",
        "keyIngredientsText": "Snail Secretion Filtrate",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Secretion Filtrate",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57301236711755
      },
      "P034": {
        "id": "P034",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/maple-energy-infusing-cream",
        "handle": "maple-energy-infusing-cream",
        "name": "Maple Energy Infusing Cream",
        "brand": "Klairs",
        "description": "Crema hidratante y nutritiva con savia de arce que fortalece la barrera cutánea y mejora firmeza, elasticidad y luminosidad.",
        "usage": "Aplicar una pequeña cantidad sobre rostro y cuello. Extender suavemente hasta su completa absorción. Apta para uso diario, mañana y noche.",
        "keyIngredientsText": "Acer Saccharum (Sugar Maple) Sap 52.87%, Squalane, Acer Rubrum Bark Extract, Acetyl Hexapeptide-8, Palmitoyl Tripeptide-1, Palmitoyl Tetrapeptide-7, Tocopherol",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I008",
            "key": "escualano",
            "name": "Escualano",
            "originalName": "Squalane",
            "weight": 5.0,
            "principal": true,
            "role": "Emoliente",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I015",
            "key": "vitamina_e",
            "name": "Vitamina E",
            "originalName": "Tocopherol",
            "weight": 4.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Antioxidante",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Acetyl Hexapeptide-8 / Palmitoyl peptides",
            "weight": 5.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302114402635
      },
      "P035": {
        "id": "P035",
        "step": "Cremas",
        "url": "https://www.soyglow.es/products/all-in-one-snail-repair-cream-75g",
        "handle": "all-in-one-snail-repair-cream-75g",
        "name": "All In One Snail Repair Cream 75g",
        "brand": "Mizon",
        "description": "Su fórmula con 92 % mucina de caracol estimula la regeneración cutánea y previene la aparición de imperfecciones y cicatrices derivadas del acné.",
        "usage": "Aplicar por todo el rostro y el cuello, y masajear suavemente. Si se tiene le piel seca, es recomendable aplicar una crema hidratante a continuación.",
        "keyIngredientsText": "Snail Mucus, Birch Black Sap, Arnica, Gentiana, Green Tea, Raspberry, Adenosine, Centella, Sodium Hyaluronate, Peptide, Beta glucan",
        "texture": "Crema",
        "ingredients": [
          {
            "id": "I002",
            "key": "centella_asiatica",
            "name": "Centella Asiática",
            "originalName": "Centella",
            "weight": 4.0,
            "principal": true,
            "role": "Reparador",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I003",
            "key": "acido_hialuronico",
            "name": "Ácido Hialurónico",
            "originalName": "Sodium Hyaluronate",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I007",
            "key": "beta_glucano",
            "name": "Beta-Glucano",
            "originalName": "Beta glucan",
            "weight": 4.0,
            "principal": true,
            "role": "Humectante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I010",
            "key": "adenosina",
            "name": "Adenosina",
            "originalName": "Adenosine",
            "weight": 4.0,
            "principal": true,
            "role": "Antiarrugas",
            "benefit": "Antiedad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I026",
            "key": "peptidos",
            "name": "Péptidos",
            "originalName": "Peptide",
            "weight": 4.0,
            "principal": true,
            "role": "Firmeza",
            "benefit": "Elasticidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I042",
            "key": "camellia_sinensis",
            "name": "Camellia Sinensis",
            "originalName": "Green Tea",
            "weight": 3.0,
            "principal": false,
            "role": "Antioxidante",
            "benefit": "Sensibilidad",
            "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I081",
            "key": "mucina_de_caracol",
            "name": "Mucina de Caracol",
            "originalName": "Snail Mucus",
            "weight": 5.0,
            "principal": true,
            "role": "Regenerador e hidratante",
            "benefit": "Reparador",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302193111371
      },
      "P036": {
        "id": "P036",
        "step": "Protector Solar",
        "url": "https://www.soyglow.es/products/relief-sun-rice-probiotics",
        "handle": "relief-sun-rice-probiotics",
        "name": "Relief Sun: Rice + Probiotics",
        "brand": "Beauty of Joseon",
        "description": "Protector solar con textura ligera y probióticos",
        "usage": "En el último paso de la rutina de día, aplicar una cantidad generosa del protector sobre el rostro y/o cualquier otra parte expuesta al sol. Recomendamos reaplicar el protector cada dos horas.",
        "keyIngredientsText": "Rice extract 30% + Grain fermented extracts",
        "texture": "Crema ligera",
        "ingredients": [
          {
            "id": "I050",
            "key": "arroz_fermentado",
            "name": "Arroz Fermentado",
            "originalName": "Grain fermented extracts",
            "weight": 4.0,
            "principal": true,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I079",
            "key": "extracto_de_arroz",
            "name": "Extracto de Arroz",
            "originalName": "Rice extract",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57013742666059
      },
      "P037": {
        "id": "P037",
        "step": "Protector Solar",
        "url": "https://www.soyglow.es/products/matte-sun-stick-mugwort-camilia-spf-50-pa",
        "handle": "matte-sun-stick-mugwort-camilia-spf-50-pa",
        "name": "Matte Sun Stick: Mugwort + Camilia (spf 50+ Pa++++)",
        "brand": "Beauty of Joseon",
        "description": "Protector solar en stick con acabado mate",
        "usage": "Reaplicar el protector solar cada dos horas. Se puede usar el stick tanto en el rostro como en el cuerpo, procurando hacer salir del envase sólo la cantidad necesaria de producto para que se conserve mejor y dure más. Aplicar extendiéndolo con suavidad sobre la piel, sin dar tirones. En el caso de que se aplique sobre maquillaje, vigilar de no moverlo.",
        "keyIngredientsText": "Rice extract 30% + grain fermented extracts",
        "texture": "Crema en Stick",
        "ingredients": [
          {
            "id": "I050",
            "key": "arroz_fermentado",
            "name": "Arroz Fermentado",
            "originalName": "Grain fermented extracts",
            "weight": 4.0,
            "principal": true,
            "role": "Glow",
            "benefit": "Glow",
            "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
          },
          {
            "id": "I079",
            "key": "extracto_de_arroz",
            "name": "Extracto de Arroz",
            "originalName": "Rice extract",
            "weight": 5.0,
            "principal": true,
            "role": "Iluminador",
            "benefit": "Sensibilidad",
            "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
          }
        ],
        "variantId": 57302260220235
      }
    },
    "relations": [
      {
        "productId": "P001",
        "ingredientId": "I020",
        "ingredientKey": "acido_glicolico",
        "ingredientName": "Ácido Glicólico",
        "originalName": "Glycolic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Renovación celular",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P001",
        "ingredientId": "I022",
        "ingredientKey": "gluconolactona",
        "ingredientName": "Gluconolactona",
        "originalName": "Gluconolactone",
        "weight": 5.0,
        "principal": true,
        "role": "Exfoliante para piel sensible",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P001",
        "ingredientId": "I044",
        "ingredientKey": "yuzu",
        "ingredientName": "Yuzu",
        "originalName": "Citrus Junos Fruit Extract",
        "weight": 4.0,
        "principal": false,
        "role": "Iluminador",
        "benefit": "Glow",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P001",
        "ingredientId": "I045",
        "ingredientKey": "papaya",
        "ingredientName": "Papaya",
        "originalName": "Carica Papaya Fruit Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Exfoliante enzimático",
        "benefit": "Glow",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P001",
        "ingredientId": "I047",
        "ingredientKey": "espino_amarillo",
        "ingredientName": "Espino Amarillo",
        "originalName": "Hippophae Rhamnoides Oil",
        "weight": 4.0,
        "principal": false,
        "role": "Glow",
        "benefit": "Glow",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Vitamin E",
        "weight": 4.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I052",
        "ingredientKey": "aceite_de_oliva",
        "ingredientName": "Aceite de Oliva",
        "originalName": "Olive",
        "weight": 4.0,
        "principal": true,
        "role": "Nutritivo",
        "benefit": "Humectante",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I053",
        "ingredientKey": "aceite_de_salvado_de_arroz",
        "ingredientName": "Aceite de Salvado de Arroz",
        "originalName": "Rice Bran",
        "weight": 5.0,
        "principal": true,
        "role": "Nutritivo",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I054",
        "ingredientKey": "aceite_de_baobab",
        "ingredientName": "Aceite de Baobab",
        "originalName": "Baobab",
        "weight": 5.0,
        "principal": true,
        "role": "Reparador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I055",
        "ingredientKey": "aceite_mct",
        "ingredientName": "Aceite MCT",
        "originalName": "MCT Oil",
        "weight": 4.0,
        "principal": false,
        "role": "Vehículo hidratante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P002",
        "ingredientId": "I056",
        "ingredientKey": "calendula",
        "ingredientName": "Caléndula",
        "originalName": "Calendula Extract",
        "weight": 3.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P003",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Camellia Leaf",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P003",
        "ingredientId": "I043",
        "ingredientKey": "camellia_japonica",
        "ingredientName": "Camellia Japonica",
        "originalName": "Camellia Oil",
        "weight": 4.0,
        "principal": true,
        "role": "Nutritivo",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P004",
        "ingredientId": "I014",
        "ingredientKey": "vitamina_c",
        "ingredientName": "Vitamina C",
        "originalName": "Ascorbic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P004",
        "ingredientId": "I036",
        "ingredientKey": "miel",
        "ingredientName": "Miel",
        "originalName": "Honey Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P005",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Vitamin E Acetate",
        "weight": 4.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P005",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail Secretion Filtrate",
        "weight": 4.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P006",
        "ingredientId": "I019",
        "ingredientKey": "acido_salicilico",
        "ingredientName": "Ácido Salicílico",
        "originalName": "BHA",
        "weight": 5.0,
        "principal": true,
        "role": "Exfoliante químico",
        "benefit": "Seborregulador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P006",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Extractos de té verde",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P007",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Hyaluronic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P007",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Green Tea (Leaf, Seed and Root Extract)",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P008",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P008",
        "ingredientId": "I002",
        "ingredientKey": "centella_asiatica",
        "ingredientName": "Centella Asiática",
        "originalName": "Centella Asiatica Leaf Water",
        "weight": 5.0,
        "principal": true,
        "role": "Reparador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P009",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 4.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P009",
        "ingredientId": "I002",
        "ingredientKey": "centella_asiatica",
        "ingredientName": "Centella Asiática",
        "originalName": "Centella Asiatica Leaf Water",
        "weight": 5.0,
        "principal": true,
        "role": "Reparador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P010",
        "ingredientId": "I082",
        "ingredientKey": "aguacate",
        "ingredientName": "Aguacate",
        "originalName": "Persea Gratissima (Avocado) Fruit Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Nutritivo y emoliente",
        "benefit": "Hidratación",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P010",
        "ingredientId": "I083",
        "ingredientKey": "arginina",
        "ingredientName": "Arginina",
        "originalName": "Arginine",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante y acondicionador",
        "benefit": "Hidratación",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P011",
        "ingredientId": "I069",
        "ingredientKey": "betaina",
        "ingredientName": "Betaína",
        "originalName": "Betaine",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P012",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P013",
        "ingredientId": "I014",
        "ingredientKey": "vitamina_c",
        "ingredientName": "Vitamina C",
        "originalName": "Ascorbic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P013",
        "ingredientId": "I069",
        "ingredientKey": "betaina",
        "ingredientName": "Betaína",
        "originalName": "Betaine",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P014",
        "ingredientId": "I069",
        "ingredientKey": "betaina",
        "ingredientName": "Betaína",
        "originalName": "Betaine",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P015",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P015",
        "ingredientId": "I025",
        "ingredientKey": "cafeina",
        "ingredientName": "Cafeína",
        "originalName": "Caffeine",
        "weight": 5.0,
        "principal": true,
        "role": "Descongestionante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P015",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Green Tea",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I005",
        "ingredientKey": "pantenol",
        "ingredientName": "Pantenol",
        "originalName": "Panthenol",
        "weight": 4.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I007",
        "ingredientKey": "beta_glucano",
        "ingredientName": "Beta-Glucano",
        "originalName": "Beta-Glucan",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I009",
        "ingredientKey": "alantoina",
        "ingredientName": "Alantoína",
        "originalName": "Allantoin",
        "weight": 4.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Tocopheryl Acetate",
        "weight": 3.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I018",
        "ingredientKey": "alfa_arbutina",
        "ingredientName": "Alfa-Arbutina",
        "originalName": "Arbutin",
        "weight": 3.0,
        "principal": false,
        "role": "Despigmentante",
        "benefit": "Manchas",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I028",
        "ingredientKey": "colageno_hidrolizado",
        "ingredientName": "Colágeno Hidrolizado",
        "originalName": "Hydrolyzed Collagen",
        "weight": 5.0,
        "principal": true,
        "role": "Hidratante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Camellia Sinensis Leaf Extract",
        "weight": 4.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P016",
        "ingredientId": "I045",
        "ingredientKey": "papaya",
        "ingredientName": "Papaya",
        "originalName": "Carica Papaya Fruit Extract",
        "weight": 3.0,
        "principal": false,
        "role": "Exfoliante enzimático",
        "benefit": "Glow",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P017",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 4.0,
        "principal": false,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P017",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Hyaluronic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P017",
        "ingredientId": "I005",
        "ingredientKey": "pantenol",
        "ingredientName": "Pantenol",
        "originalName": "Panthenol",
        "weight": 4.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P017",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": false,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P017",
        "ingredientId": "I028",
        "ingredientKey": "colageno_hidrolizado",
        "ingredientName": "Colágeno Hidrolizado",
        "originalName": "Collagen",
        "weight": 5.0,
        "principal": true,
        "role": "Hidratante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P018",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Hyaluronic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P018",
        "ingredientId": "I005",
        "ingredientKey": "pantenol",
        "ingredientName": "Pantenol",
        "originalName": "Panthenol",
        "weight": 4.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P018",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Green Tea",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P019",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Multi-layered hyaluronic acid",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P019",
        "ingredientId": "I008",
        "ingredientKey": "escualano",
        "ingredientName": "Escualano",
        "originalName": "Plant-based squalane",
        "weight": 5.0,
        "principal": true,
        "role": "Emoliente",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P020",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P020",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P020",
        "ingredientId": "I014",
        "ingredientKey": "vitamina_c",
        "ingredientName": "Vitamina C",
        "originalName": "3-O-Ethyl Ascorbic Acid",
        "weight": 4.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Manchas",
        "evidence": "Equivalencia derivado de vitamina C; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P020",
        "ingredientId": "I017",
        "ingredientKey": "acido_tranexamico",
        "ingredientName": "Ácido Tranexámico",
        "originalName": "Tranexamic Acid",
        "weight": 4.0,
        "principal": true,
        "role": "Despigmentante",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P021",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P021",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "BS-HA 7 Complex (Hyaluronic)",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P021",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P021",
        "ingredientId": "I026",
        "ingredientKey": "peptidos",
        "ingredientName": "Péptidos",
        "originalName": "Eternal P Complex",
        "weight": 3.0,
        "principal": false,
        "role": "Firmeza",
        "benefit": "Elasticidad",
        "evidence": "Equivalencia de complejo peptídico; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P021",
        "ingredientId": "I028",
        "ingredientKey": "colageno_hidrolizado",
        "ingredientName": "Colágeno Hidrolizado",
        "originalName": "ATA Collagen 3 Complex",
        "weight": 4.0,
        "principal": true,
        "role": "Hidratante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P022",
        "ingredientId": "I039",
        "ingredientKey": "ginseng",
        "ingredientName": "Ginseng",
        "originalName": "Ginseng root water",
        "weight": 5.0,
        "principal": true,
        "role": "Antiedad",
        "benefit": "Antioxidante",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P022",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail mucin",
        "weight": 5.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P023",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamida",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P023",
        "ingredientId": "I009",
        "ingredientKey": "alantoina",
        "ingredientName": "Alantoína",
        "originalName": "Allantoin",
        "weight": 4.0,
        "principal": false,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P023",
        "ingredientId": "I064",
        "ingredientKey": "zinc_pca",
        "ingredientName": "Zinc PCA",
        "originalName": "Zinc PCA",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Seborregulador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Hyaluronic Acid",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I014",
        "ingredientKey": "vitamina_c",
        "ingredientName": "Vitamina C",
        "originalName": "L-Ascorbic Acid (Vitamin C)",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Vitamin E",
        "weight": 4.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I024",
        "ingredientKey": "acido_ferulico",
        "ingredientName": "Ácido Ferúlico",
        "originalName": "Ferulic Acid",
        "weight": 4.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Green Tea Extracts",
        "weight": 4.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I044",
        "ingredientKey": "yuzu",
        "ingredientName": "Yuzu",
        "originalName": "Yuzu Water",
        "weight": 5.0,
        "principal": true,
        "role": "Iluminador",
        "benefit": "Glow",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P024",
        "ingredientId": "I047",
        "ingredientKey": "espino_amarillo",
        "ingredientName": "Espino Amarillo",
        "originalName": "Sea Buckthorn",
        "weight": 4.0,
        "principal": false,
        "role": "Glow",
        "benefit": "Glow",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P025",
        "ingredientId": "I005",
        "ingredientKey": "pantenol",
        "ingredientName": "Pantenol",
        "originalName": "Panthenol",
        "weight": 5.0,
        "principal": true,
        "role": "Calmante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 4.0,
        "principal": false,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I008",
        "ingredientKey": "escualano",
        "ingredientName": "Escualano",
        "originalName": "Squalane",
        "weight": 4.0,
        "principal": false,
        "role": "Emoliente",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I026",
        "ingredientKey": "peptidos",
        "ingredientName": "Péptidos",
        "originalName": "Peptide",
        "weight": 4.0,
        "principal": true,
        "role": "Firmeza",
        "benefit": "Elasticidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I030",
        "ingredientKey": "egf",
        "ingredientName": "EGF",
        "originalName": "EGF",
        "weight": 5.0,
        "principal": true,
        "role": "Regeneración",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P026",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail Mucin Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 4.0,
        "principal": false,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I008",
        "ingredientKey": "escualano",
        "ingredientName": "Escualano",
        "originalName": "Squalane",
        "weight": 4.0,
        "principal": false,
        "role": "Emoliente",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I026",
        "ingredientKey": "peptidos",
        "ingredientName": "Péptidos",
        "originalName": "Peptide",
        "weight": 4.0,
        "principal": true,
        "role": "Firmeza",
        "benefit": "Elasticidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I030",
        "ingredientKey": "egf",
        "ingredientName": "EGF",
        "originalName": "EGF",
        "weight": 5.0,
        "principal": true,
        "role": "Regeneración",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P027",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail Mucin Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P028",
        "ingredientId": "I002",
        "ingredientKey": "centella_asiatica",
        "ingredientName": "Centella Asiática",
        "originalName": "Centella Asiatica Extract",
        "weight": 5.0,
        "principal": true,
        "role": "Reparador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P028",
        "ingredientId": "I007",
        "ingredientKey": "beta_glucano",
        "ingredientName": "Beta-Glucano",
        "originalName": "β-glucan",
        "weight": 5.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P029",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Tocopherol",
        "weight": 4.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P029",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Camellia Sinensis Leaf Water / extracts",
        "weight": 5.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P030",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P030",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Sodium Hyaluronate",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P030",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P031",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P031",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P031",
        "ingredientId": "I014",
        "ingredientKey": "vitamina_c",
        "ingredientName": "Vitamina C",
        "originalName": "Ascorbic Acid",
        "weight": 4.0,
        "principal": true,
        "role": "Antioxidante",
        "benefit": "Manchas",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P032",
        "ingredientId": "I001",
        "ingredientKey": "niacinamida",
        "ingredientName": "Niacinamida",
        "originalName": "Niacinamide",
        "weight": 5.0,
        "principal": true,
        "role": "Seborregulador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P032",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P032",
        "ingredientId": "I028",
        "ingredientKey": "colageno_hidrolizado",
        "ingredientName": "Colágeno Hidrolizado",
        "originalName": "Hydrolyzed Collagen",
        "weight": 4.0,
        "principal": true,
        "role": "Hidratante",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P033",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail Secretion Filtrate",
        "weight": 5.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P034",
        "ingredientId": "I008",
        "ingredientKey": "escualano",
        "ingredientName": "Escualano",
        "originalName": "Squalane",
        "weight": 5.0,
        "principal": true,
        "role": "Emoliente",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P034",
        "ingredientId": "I015",
        "ingredientKey": "vitamina_e",
        "ingredientName": "Vitamina E",
        "originalName": "Tocopherol",
        "weight": 4.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Antioxidante",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P034",
        "ingredientId": "I026",
        "ingredientKey": "peptidos",
        "ingredientName": "Péptidos",
        "originalName": "Acetyl Hexapeptide-8 / Palmitoyl peptides",
        "weight": 5.0,
        "principal": true,
        "role": "Firmeza",
        "benefit": "Elasticidad",
        "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I002",
        "ingredientKey": "centella_asiatica",
        "ingredientName": "Centella Asiática",
        "originalName": "Centella",
        "weight": 4.0,
        "principal": true,
        "role": "Reparador",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I003",
        "ingredientKey": "acido_hialuronico",
        "ingredientName": "Ácido Hialurónico",
        "originalName": "Sodium Hyaluronate",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia INCI; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I007",
        "ingredientKey": "beta_glucano",
        "ingredientName": "Beta-Glucano",
        "originalName": "Beta glucan",
        "weight": 4.0,
        "principal": true,
        "role": "Humectante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I010",
        "ingredientKey": "adenosina",
        "ingredientName": "Adenosina",
        "originalName": "Adenosine",
        "weight": 4.0,
        "principal": true,
        "role": "Antiarrugas",
        "benefit": "Antiedad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I026",
        "ingredientKey": "peptidos",
        "ingredientName": "Péptidos",
        "originalName": "Peptide",
        "weight": 4.0,
        "principal": true,
        "role": "Firmeza",
        "benefit": "Elasticidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I042",
        "ingredientKey": "camellia_sinensis",
        "ingredientName": "Camellia Sinensis",
        "originalName": "Green Tea",
        "weight": 3.0,
        "principal": false,
        "role": "Antioxidante",
        "benefit": "Sensibilidad",
        "evidence": "Equivalencia normalizada; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P035",
        "ingredientId": "I081",
        "ingredientKey": "mucina_de_caracol",
        "ingredientName": "Mucina de Caracol",
        "originalName": "Snail Mucus",
        "weight": 5.0,
        "principal": true,
        "role": "Regenerador e hidratante",
        "benefit": "Reparador",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P036",
        "ingredientId": "I050",
        "ingredientKey": "arroz_fermentado",
        "ingredientName": "Arroz Fermentado",
        "originalName": "Grain fermented extracts",
        "weight": 4.0,
        "principal": true,
        "role": "Glow",
        "benefit": "Glow",
        "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P036",
        "ingredientId": "I079",
        "ingredientKey": "extracto_de_arroz",
        "ingredientName": "Extracto de Arroz",
        "originalName": "Rice extract",
        "weight": 5.0,
        "principal": true,
        "role": "Iluminador",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P037",
        "ingredientId": "I050",
        "ingredientKey": "arroz_fermentado",
        "ingredientName": "Arroz Fermentado",
        "originalName": "Grain fermented extracts",
        "weight": 4.0,
        "principal": true,
        "role": "Glow",
        "benefit": "Glow",
        "evidence": "Equivalencia de categoría; basado en la columna 'Ingredientes clave' de 01_Productos"
      },
      {
        "productId": "P037",
        "ingredientId": "I079",
        "ingredientKey": "extracto_de_arroz",
        "ingredientName": "Extracto de Arroz",
        "originalName": "Rice extract",
        "weight": 5.0,
        "principal": true,
        "role": "Iluminador",
        "benefit": "Sensibilidad",
        "evidence": "Directa; basado en la columna 'Ingredientes clave' de 01_Productos"
      }
    ]
  },
  "knowledge": {
    "ingredients": [
      {
        "id": "I001",
        "key": "niacinamida",
        "name": "Niacinamida",
        "synonyms": [
          "Vitamin B3"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 5,
          "spots": 5,
          "glow": 4,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      {
        "id": "I002",
        "key": "centella_asiatica",
        "name": "Centella Asiática",
        "synonyms": [
          "CICA"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      {
        "id": "I003",
        "key": "acido_hialuronico",
        "name": "Ácido Hialurónico",
        "synonyms": [
          "HA"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 3,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I004",
        "key": "ceramidas",
        "name": "Ceramidas",
        "synonyms": [
          "Ceramide NP/AP/EOP"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Barrera cutánea"
      },
      {
        "id": "I005",
        "key": "pantenol",
        "name": "Pantenol",
        "synonyms": [
          "Provitamina B5"
        ],
        "type": "Vitamina",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I006",
        "key": "madecassoside",
        "name": "Madecassoside",
        "synonyms": [
          "Madecassoside"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      {
        "id": "I007",
        "key": "beta_glucano",
        "name": "Beta-Glucano",
        "synonyms": [
          "Beta Glucan"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I008",
        "key": "escualano",
        "name": "Escualano",
        "synonyms": [
          "Squalane"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Emoliente"
      },
      {
        "id": "I009",
        "key": "alantoina",
        "name": "Alantoína",
        "synonyms": [
          "Allantoin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I010",
        "key": "adenosina",
        "name": "Adenosina",
        "synonyms": [
          "Adenosine"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiarrugas"
      },
      {
        "id": "I011",
        "key": "retinol",
        "name": "Retinol",
        "synonyms": [
          "Vitamin A"
        ],
        "type": "Retinoide",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 3,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Prec."
        },
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "pregnancy": "No",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Renovación celular"
      },
      {
        "id": "I012",
        "key": "retinal",
        "name": "Retinal",
        "synonyms": [
          "Retinaldehyde"
        ],
        "type": "Retinoide",
        "scores": {
          "sebum": 1,
          "acne": 4,
          "pores": 2,
          "spots": 3,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Prec."
        },
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "pregnancy": "No",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Retinoide avanzado"
      },
      {
        "id": "I013",
        "key": "bakuchiol",
        "name": "Bakuchiol",
        "synonyms": [
          "Bakuchiol"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Alternativa al retinol"
      },
      {
        "id": "I014",
        "key": "vitamina_c",
        "name": "Vitamina C",
        "synonyms": [
          "Ascorbic Acid"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 5,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I015",
        "key": "vitamina_e",
        "name": "Vitamina E",
        "synonyms": [
          "Tocopherol"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I016",
        "key": "acido_azelaico",
        "name": "Ácido Azelaico",
        "synonyms": [
          "Azelaic Acid"
        ],
        "type": "Ácido",
        "scores": {
          "sebum": 3,
          "acne": 4,
          "pores": 2,
          "spots": 4,
          "glow": 3,
          "hydration": 2,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 1,
          "sebumControl": 3,
          "humectant": 2,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiacné"
      },
      {
        "id": "I017",
        "key": "acido_tranexamico",
        "name": "Ácido Tranexámico",
        "synonyms": [
          "Tranexamic Acid"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      {
        "id": "I018",
        "key": "alfa_arbutina",
        "name": "Alfa-Arbutina",
        "synonyms": [
          "Alpha Arbutin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      {
        "id": "I019",
        "key": "acido_salicilico",
        "name": "Ácido Salicílico",
        "synonyms": [
          "BHA"
        ],
        "type": "Ácido",
        "scores": {
          "sebum": 5,
          "acne": 5,
          "pores": 5,
          "spots": 2,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 1,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 5,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "No",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante químico"
      },
      {
        "id": "I020",
        "key": "acido_glicolico",
        "name": "Ácido Glicólico",
        "synonyms": [
          "Glycolic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 3,
          "spots": 5,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 5,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Renovación celular"
      },
      {
        "id": "I021",
        "key": "acido_lactico",
        "name": "Ácido Láctico",
        "synonyms": [
          "Lactic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 2,
          "spots": 4,
          "glow": 4,
          "hydration": 3,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 4,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante suave"
      },
      {
        "id": "I022",
        "key": "gluconolactona",
        "name": "Gluconolactona",
        "synonyms": [
          "PHA"
        ],
        "type": "PHA",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 3,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 3,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante para piel sensible"
      },
      {
        "id": "I023",
        "key": "acido_mandelico",
        "name": "Ácido Mandélico",
        "synonyms": [
          "Mandelic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 3,
          "acne": 4,
          "pores": 3,
          "spots": 4,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 4,
          "sebumControl": 3,
          "humectant": 2,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Acné y manchas"
      },
      {
        "id": "I024",
        "key": "acido_ferulico",
        "name": "Ácido Ferúlico",
        "synonyms": [
          "Ferulic Acid"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 4,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 1,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I025",
        "key": "cafeina",
        "name": "Cafeína",
        "synonyms": [
          "Caffeine"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Descongestionante"
      },
      {
        "id": "I026",
        "key": "peptidos",
        "name": "Péptidos",
        "synonyms": [
          "Peptides"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Firmeza"
      },
      {
        "id": "I027",
        "key": "copper_peptides",
        "name": "Copper Peptides",
        "synonyms": [
          "GHK-Cu"
        ],
        "type": "Péptido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Regenerador"
      },
      {
        "id": "I028",
        "key": "colageno_hidrolizado",
        "name": "Colágeno Hidrolizado",
        "synonyms": [
          "Hydrolyzed Collagen"
        ],
        "type": "Proteína",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      {
        "id": "I029",
        "key": "elastina",
        "name": "Elastina",
        "synonyms": [
          "Elastin"
        ],
        "type": "Proteína",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 1,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐",
        "primaryFunction": "Elasticidad"
      },
      {
        "id": "I030",
        "key": "egf",
        "name": "EGF",
        "synonyms": [
          "Epidermal Growth Factor"
        ],
        "type": "Factor crecimiento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Regeneración"
      },
      {
        "id": "I031",
        "key": "bifida_ferment_lysate",
        "name": "Bifida Ferment Lysate",
        "synonyms": [
          "Bifida"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparación barrera"
      },
      {
        "id": "I032",
        "key": "galactomyces_ferment",
        "name": "Galactomyces Ferment",
        "synonyms": [
          "Galactomyces"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      {
        "id": "I033",
        "key": "saccharomyces_ferment",
        "name": "Saccharomyces Ferment",
        "synonyms": [
          "Saccharomyces"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I034",
        "key": "lactobacillus_ferment",
        "name": "Lactobacillus Ferment",
        "synonyms": [
          "Probiotics"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Microbioma"
      },
      {
        "id": "I035",
        "key": "propoleo",
        "name": "Propóleo",
        "synonyms": [
          "Propolis"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 2,
          "glow": 4,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I036",
        "key": "miel",
        "name": "Miel",
        "synonyms": [
          "Honey Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I037",
        "key": "aloe_vera",
        "name": "Aloe Vera",
        "synonyms": [
          "Aloe Barbadensis"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I038",
        "key": "regaliz",
        "name": "Regaliz",
        "synonyms": [
          "Licorice Root"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      {
        "id": "I039",
        "key": "ginseng",
        "name": "Ginseng",
        "synonyms": [
          "Panax Ginseng"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiedad"
      },
      {
        "id": "I040",
        "key": "artemisa",
        "name": "Artemisa",
        "synonyms": [
          "Mugwort"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I041",
        "key": "houttuynia_cordata",
        "name": "Houttuynia Cordata",
        "synonyms": [
          "Heartleaf"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 4,
          "acne": 4,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 4,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante y antiacné"
      },
      {
        "id": "I042",
        "key": "camellia_sinensis",
        "name": "Camellia Sinensis",
        "synonyms": [
          "Té Verde"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 4,
          "acne": 3,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 5,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 4,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I043",
        "key": "camellia_japonica",
        "name": "Camellia Japonica",
        "synonyms": [
          "Camelia"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I044",
        "key": "yuzu",
        "name": "Yuzu",
        "synonyms": [
          "Citrus Junos"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 5,
          "soothing": 1,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Iluminador"
      },
      {
        "id": "I045",
        "key": "papaya",
        "name": "Papaya",
        "synonyms": [
          "Carica Papaya"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 2,
          "spots": 4,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 3,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante enzimático"
      },
      {
        "id": "I046",
        "key": "granada",
        "name": "Granada",
        "synonyms": [
          "Punica Granatum"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I047",
        "key": "espino_amarillo",
        "name": "Espino Amarillo",
        "synonyms": [
          "Sea Buckthorn"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      {
        "id": "I048",
        "key": "baobab",
        "name": "Baobab",
        "synonyms": [
          "Adansonia Digitata"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      {
        "id": "I049",
        "key": "aloe_ferment",
        "name": "Aloe Ferment",
        "synonyms": [
          "Fermented Aloe"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I050",
        "key": "arroz_fermentado",
        "name": "Arroz Fermentado",
        "synonyms": [
          "Rice Ferment"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      {
        "id": "I051",
        "key": "aceite_de_jojoba",
        "name": "Aceite de Jojoba",
        "synonyms": [
          "Jojoba Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Emoliente"
      },
      {
        "id": "I052",
        "key": "aceite_de_oliva",
        "name": "Aceite de Oliva",
        "synonyms": [
          "Olive Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I053",
        "key": "aceite_de_salvado_de_arroz",
        "name": "Aceite de Salvado de Arroz",
        "synonyms": [
          "Rice Bran Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 3,
          "glow": 4,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I054",
        "key": "aceite_de_baobab",
        "name": "Aceite de Baobab",
        "synonyms": [
          "Baobab Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      {
        "id": "I055",
        "key": "aceite_mct",
        "name": "Aceite MCT",
        "synonyms": [
          "Caprylic/Capric Triglyceride"
        ],
        "type": "Emoliente",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Vehículo hidratante"
      },
      {
        "id": "I056",
        "key": "calendula",
        "name": "Caléndula",
        "synonyms": [
          "Calendula Officinalis"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I057",
        "key": "bambu",
        "name": "Bambú",
        "synonyms": [
          "Bamboo Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      {
        "id": "I058",
        "key": "te_negro",
        "name": "Té Negro",
        "synonyms": [
          "Black Tea"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I059",
        "key": "rosa_damascena",
        "name": "Rosa Damascena",
        "synonyms": [
          "Rose Damask"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I060",
        "key": "hamamelis",
        "name": "Hamamelis",
        "synonyms": [
          "Witch Hazel"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 3,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 2,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 1,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      {
        "id": "I061",
        "key": "kaolin",
        "name": "Kaolin",
        "synonyms": [
          "White Clay"
        ],
        "type": "Arcilla",
        "scores": {
          "sebum": 4,
          "acne": 3,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 3,
          "sebumControl": 4,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Absorbente"
      },
      {
        "id": "I062",
        "key": "bentonite",
        "name": "Bentonite",
        "synonyms": [
          "Bentonite Clay"
        ],
        "type": "Arcilla",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 3,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Purificante"
      },
      {
        "id": "I063",
        "key": "carbon_vegetal",
        "name": "Carbón Vegetal",
        "synonyms": [
          "Charcoal"
        ],
        "type": "Mineral",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 2,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Detoxificante"
      },
      {
        "id": "I064",
        "key": "zinc_pca",
        "name": "Zinc PCA",
        "synonyms": [
          "Zinc PCA"
        ],
        "type": "Mineral",
        "scores": {
          "sebum": 5,
          "acne": 5,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 3,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 2,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      {
        "id": "I065",
        "key": "sodium_pca",
        "name": "Sodium PCA",
        "synonyms": [
          "PCA Sódico"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I066",
        "key": "sodium_lactate",
        "name": "Sodium Lactate",
        "synonyms": [
          "Lactato Sódico"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 1,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I067",
        "key": "urea",
        "name": "Urea",
        "synonyms": [
          "Urea"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 2,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Hidratación intensa"
      },
      {
        "id": "I068",
        "key": "trehalosa",
        "name": "Trehalosa",
        "synonyms": [
          "Trehalose"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Protección celular"
      },
      {
        "id": "I069",
        "key": "betaina",
        "name": "Betaína",
        "synonyms": [
          "Betaine"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      {
        "id": "I070",
        "key": "ectoina",
        "name": "Ectoína",
        "synonyms": [
          "Ectoin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Protector celular"
      },
      {
        "id": "I071",
        "key": "bisabolol",
        "name": "Bisabolol",
        "synonyms": [
          "Alpha-Bisabolol"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 2,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      {
        "id": "I072",
        "key": "dipotassium_glycyrrhizate",
        "name": "Dipotassium Glycyrrhizate",
        "synonyms": [
          "Regaliz Derivado"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 4,
          "glow": 3,
          "hydration": 2,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiinflamatorio"
      },
      {
        "id": "I073",
        "key": "fitosfingosina",
        "name": "Fitosfingosina",
        "synonyms": [
          "Phytosphingosine"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 1,
          "acne": 3,
          "pores": 2,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 2,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Barrera cutánea"
      },
      {
        "id": "I074",
        "key": "colesterol",
        "name": "Colesterol",
        "synonyms": [
          "Cholesterol"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 1,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      {
        "id": "I075",
        "key": "escualeno",
        "name": "Escualeno",
        "synonyms": [
          "Squalene"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I076",
        "key": "jalea_real",
        "name": "Jalea Real",
        "synonyms": [
          "Royal Jelly"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      {
        "id": "I077",
        "key": "soja_fermentada",
        "name": "Soja Fermentada",
        "synonyms": [
          "Soybean Ferment"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiedad"
      },
      {
        "id": "I078",
        "key": "extracto_de_soja",
        "name": "Extracto de Soja",
        "synonyms": [
          "Soy Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      {
        "id": "I079",
        "key": "extracto_de_arroz",
        "name": "Extracto de Arroz",
        "synonyms": [
          "Rice Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 4,
          "glow": 5,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Iluminador"
      },
      {
        "id": "I080",
        "key": "extracto_de_judia_mungo",
        "name": "Extracto de Judía Mungo",
        "synonyms": [
          "Mung Bean"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 3,
          "acne": 3,
          "pores": 2,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 3,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Purificante"
      },
      {
        "id": "I081",
        "key": "mucina_de_caracol",
        "name": "Mucina de Caracol",
        "synonyms": [
          "Snail Secretion Filtrate",
          "Snail Mucin",
          "Snail Mucus"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 3,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 5,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Alta",
        "primaryFunction": "Regenerador e hidratante"
      },
      {
        "id": "I082",
        "key": "aguacate",
        "name": "Aguacate",
        "synonyms": [
          "Persea Gratissima Fruit Extract",
          "Avocado Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Media",
        "primaryFunction": "Nutritivo y emoliente"
      },
      {
        "id": "I083",
        "key": "arginina",
        "name": "Arginina",
        "synonyms": [
          "Arginine"
        ],
        "type": "Aminoácido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 3,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Media",
        "primaryFunction": "Humectante y acondicionador"
      }
    ],
    "ingredientsByKey": {
      "niacinamida": {
        "id": "I001",
        "key": "niacinamida",
        "name": "Niacinamida",
        "synonyms": [
          "Vitamin B3"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 5,
          "spots": 5,
          "glow": 4,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      "centella_asiatica": {
        "id": "I002",
        "key": "centella_asiatica",
        "name": "Centella Asiática",
        "synonyms": [
          "CICA"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      "acido_hialuronico": {
        "id": "I003",
        "key": "acido_hialuronico",
        "name": "Ácido Hialurónico",
        "synonyms": [
          "HA"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 3,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "ceramidas": {
        "id": "I004",
        "key": "ceramidas",
        "name": "Ceramidas",
        "synonyms": [
          "Ceramide NP/AP/EOP"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Barrera cutánea"
      },
      "pantenol": {
        "id": "I005",
        "key": "pantenol",
        "name": "Pantenol",
        "synonyms": [
          "Provitamina B5"
        ],
        "type": "Vitamina",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "madecassoside": {
        "id": "I006",
        "key": "madecassoside",
        "name": "Madecassoside",
        "synonyms": [
          "Madecassoside"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      "beta_glucano": {
        "id": "I007",
        "key": "beta_glucano",
        "name": "Beta-Glucano",
        "synonyms": [
          "Beta Glucan"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "escualano": {
        "id": "I008",
        "key": "escualano",
        "name": "Escualano",
        "synonyms": [
          "Squalane"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Emoliente"
      },
      "alantoina": {
        "id": "I009",
        "key": "alantoina",
        "name": "Alantoína",
        "synonyms": [
          "Allantoin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 1,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "adenosina": {
        "id": "I010",
        "key": "adenosina",
        "name": "Adenosina",
        "synonyms": [
          "Adenosine"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiarrugas"
      },
      "retinol": {
        "id": "I011",
        "key": "retinol",
        "name": "Retinol",
        "synonyms": [
          "Vitamin A"
        ],
        "type": "Retinoide",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 3,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Prec."
        },
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "pregnancy": "No",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Renovación celular"
      },
      "retinal": {
        "id": "I012",
        "key": "retinal",
        "name": "Retinal",
        "synonyms": [
          "Retinaldehyde"
        ],
        "type": "Retinoide",
        "scores": {
          "sebum": 1,
          "acne": 4,
          "pores": 2,
          "spots": 3,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Prec."
        },
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "pregnancy": "No",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Retinoide avanzado"
      },
      "bakuchiol": {
        "id": "I013",
        "key": "bakuchiol",
        "name": "Bakuchiol",
        "synonyms": [
          "Bakuchiol"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Alternativa al retinol"
      },
      "vitamina_c": {
        "id": "I014",
        "key": "vitamina_c",
        "name": "Vitamina C",
        "synonyms": [
          "Ascorbic Acid"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 5,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Prec.",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "vitamina_e": {
        "id": "I015",
        "key": "vitamina_e",
        "name": "Vitamina E",
        "synonyms": [
          "Tocopherol"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "acido_azelaico": {
        "id": "I016",
        "key": "acido_azelaico",
        "name": "Ácido Azelaico",
        "synonyms": [
          "Azelaic Acid"
        ],
        "type": "Ácido",
        "scores": {
          "sebum": 3,
          "acne": 4,
          "pores": 2,
          "spots": 4,
          "glow": 3,
          "hydration": 2,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 1,
          "sebumControl": 3,
          "humectant": 2,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiacné"
      },
      "acido_tranexamico": {
        "id": "I017",
        "key": "acido_tranexamico",
        "name": "Ácido Tranexámico",
        "synonyms": [
          "Tranexamic Acid"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      "alfa_arbutina": {
        "id": "I018",
        "key": "alfa_arbutina",
        "name": "Alfa-Arbutina",
        "synonyms": [
          "Alpha Arbutin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      "acido_salicilico": {
        "id": "I019",
        "key": "acido_salicilico",
        "name": "Ácido Salicílico",
        "synonyms": [
          "BHA"
        ],
        "type": "Ácido",
        "scores": {
          "sebum": 5,
          "acne": 5,
          "pores": 5,
          "spots": 2,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 1,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 5,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "No",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante químico"
      },
      "acido_glicolico": {
        "id": "I020",
        "key": "acido_glicolico",
        "name": "Ácido Glicólico",
        "synonyms": [
          "Glycolic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 3,
          "spots": 5,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 0,
          "repair": 1,
          "exfoliation": 5,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Renovación celular"
      },
      "acido_lactico": {
        "id": "I021",
        "key": "acido_lactico",
        "name": "Ácido Láctico",
        "synonyms": [
          "Lactic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 2,
          "spots": 4,
          "glow": 4,
          "hydration": 3,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 4,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante suave"
      },
      "gluconolactona": {
        "id": "I022",
        "key": "gluconolactona",
        "name": "Gluconolactona",
        "synonyms": [
          "PHA"
        ],
        "type": "PHA",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 2,
          "spots": 3,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 3,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante para piel sensible"
      },
      "acido_mandelico": {
        "id": "I023",
        "key": "acido_mandelico",
        "name": "Ácido Mandélico",
        "synonyms": [
          "Mandelic Acid"
        ],
        "type": "AHA",
        "scores": {
          "sebum": 3,
          "acne": 4,
          "pores": 3,
          "spots": 4,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 4,
          "sebumControl": 3,
          "humectant": 2,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Prec.",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "No"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Acné y manchas"
      },
      "acido_ferulico": {
        "id": "I024",
        "key": "acido_ferulico",
        "name": "Ácido Ferúlico",
        "synonyms": [
          "Ferulic Acid"
        ],
        "type": "Antioxidante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 4,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 1,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 1,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "cafeina": {
        "id": "I025",
        "key": "cafeina",
        "name": "Cafeína",
        "synonyms": [
          "Caffeine"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 1,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Descongestionante"
      },
      "peptidos": {
        "id": "I026",
        "key": "peptidos",
        "name": "Péptidos",
        "synonyms": [
          "Peptides"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Firmeza"
      },
      "copper_peptides": {
        "id": "I027",
        "key": "copper_peptides",
        "name": "Copper Peptides",
        "synonyms": [
          "GHK-Cu"
        ],
        "type": "Péptido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Regenerador"
      },
      "colageno_hidrolizado": {
        "id": "I028",
        "key": "colageno_hidrolizado",
        "name": "Colágeno Hidrolizado",
        "synonyms": [
          "Hydrolyzed Collagen"
        ],
        "type": "Proteína",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      "elastina": {
        "id": "I029",
        "key": "elastina",
        "name": "Elastina",
        "synonyms": [
          "Elastin"
        ],
        "type": "Proteína",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 1,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐",
        "primaryFunction": "Elasticidad"
      },
      "egf": {
        "id": "I030",
        "key": "egf",
        "name": "EGF",
        "synonyms": [
          "Epidermal Growth Factor"
        ],
        "type": "Factor crecimiento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 5,
          "elasticity": 5,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Regeneración"
      },
      "bifida_ferment_lysate": {
        "id": "I031",
        "key": "bifida_ferment_lysate",
        "name": "Bifida Ferment Lysate",
        "synonyms": [
          "Bifida"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 4,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparación barrera"
      },
      "galactomyces_ferment": {
        "id": "I032",
        "key": "galactomyces_ferment",
        "name": "Galactomyces Ferment",
        "synonyms": [
          "Galactomyces"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      "saccharomyces_ferment": {
        "id": "I033",
        "key": "saccharomyces_ferment",
        "name": "Saccharomyces Ferment",
        "synonyms": [
          "Saccharomyces"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "lactobacillus_ferment": {
        "id": "I034",
        "key": "lactobacillus_ferment",
        "name": "Lactobacillus Ferment",
        "synonyms": [
          "Probiotics"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Microbioma"
      },
      "propoleo": {
        "id": "I035",
        "key": "propoleo",
        "name": "Propóleo",
        "synonyms": [
          "Propolis"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 2,
          "glow": 4,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "miel": {
        "id": "I036",
        "key": "miel",
        "name": "Miel",
        "synonyms": [
          "Honey Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "aloe_vera": {
        "id": "I037",
        "key": "aloe_vera",
        "name": "Aloe Vera",
        "synonyms": [
          "Aloe Barbadensis"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "regaliz": {
        "id": "I038",
        "key": "regaliz",
        "name": "Regaliz",
        "synonyms": [
          "Licorice Root"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 5,
          "glow": 4,
          "hydration": 2,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Despigmentante"
      },
      "ginseng": {
        "id": "I039",
        "key": "ginseng",
        "name": "Ginseng",
        "synonyms": [
          "Panax Ginseng"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 4,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiedad"
      },
      "artemisa": {
        "id": "I040",
        "key": "artemisa",
        "name": "Artemisa",
        "synonyms": [
          "Mugwort"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "houttuynia_cordata": {
        "id": "I041",
        "key": "houttuynia_cordata",
        "name": "Houttuynia Cordata",
        "synonyms": [
          "Heartleaf"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 4,
          "acne": 4,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 4,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante y antiacné"
      },
      "camellia_sinensis": {
        "id": "I042",
        "key": "camellia_sinensis",
        "name": "Camellia Sinensis",
        "synonyms": [
          "Té Verde"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 4,
          "acne": 3,
          "pores": 2,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 5,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 4,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "camellia_japonica": {
        "id": "I043",
        "key": "camellia_japonica",
        "name": "Camellia Japonica",
        "synonyms": [
          "Camelia"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "yuzu": {
        "id": "I044",
        "key": "yuzu",
        "name": "Yuzu",
        "synonyms": [
          "Citrus Junos"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 5,
          "soothing": 1,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 2,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Iluminador"
      },
      "papaya": {
        "id": "I045",
        "key": "papaya",
        "name": "Papaya",
        "synonyms": [
          "Carica Papaya"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 2,
          "spots": 4,
          "glow": 5,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 1,
          "repair": 2,
          "exfoliation": 3,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Exfoliante enzimático"
      },
      "granada": {
        "id": "I046",
        "key": "granada",
        "name": "Granada",
        "synonyms": [
          "Punica Granatum"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "espino_amarillo": {
        "id": "I047",
        "key": "espino_amarillo",
        "name": "Espino Amarillo",
        "synonyms": [
          "Sea Buckthorn"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      "baobab": {
        "id": "I048",
        "key": "baobab",
        "name": "Baobab",
        "synonyms": [
          "Adansonia Digitata"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      "aloe_ferment": {
        "id": "I049",
        "key": "aloe_ferment",
        "name": "Aloe Ferment",
        "synonyms": [
          "Fermented Aloe"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "arroz_fermentado": {
        "id": "I050",
        "key": "arroz_fermentado",
        "name": "Arroz Fermentado",
        "synonyms": [
          "Rice Ferment"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 4,
          "glow": 5,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Glow"
      },
      "aceite_de_jojoba": {
        "id": "I051",
        "key": "aceite_de_jojoba",
        "name": "Aceite de Jojoba",
        "synonyms": [
          "Jojoba Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 2,
          "acne": 2,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Emoliente"
      },
      "aceite_de_oliva": {
        "id": "I052",
        "key": "aceite_de_oliva",
        "name": "Aceite de Oliva",
        "synonyms": [
          "Olive Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "aceite_de_salvado_de_arroz": {
        "id": "I053",
        "key": "aceite_de_salvado_de_arroz",
        "name": "Aceite de Salvado de Arroz",
        "synonyms": [
          "Rice Bran Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 3,
          "glow": 4,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "aceite_de_baobab": {
        "id": "I054",
        "key": "aceite_de_baobab",
        "name": "Aceite de Baobab",
        "synonyms": [
          "Baobab Oil"
        ],
        "type": "Aceite",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      "aceite_mct": {
        "id": "I055",
        "key": "aceite_mct",
        "name": "Aceite MCT",
        "synonyms": [
          "Caprylic/Capric Triglyceride"
        ],
        "type": "Emoliente",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Vehículo hidratante"
      },
      "calendula": {
        "id": "I056",
        "key": "calendula",
        "name": "Caléndula",
        "synonyms": [
          "Calendula Officinalis"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "bambu": {
        "id": "I057",
        "key": "bambu",
        "name": "Bambú",
        "synonyms": [
          "Bamboo Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Hidratante"
      },
      "te_negro": {
        "id": "I058",
        "key": "te_negro",
        "name": "Té Negro",
        "synonyms": [
          "Black Tea"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 2,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 2,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 5,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 2,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "rosa_damascena": {
        "id": "I059",
        "key": "rosa_damascena",
        "name": "Rosa Damascena",
        "synonyms": [
          "Rose Damask"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 2,
          "glow": 3,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "hamamelis": {
        "id": "I060",
        "key": "hamamelis",
        "name": "Hamamelis",
        "synonyms": [
          "Witch Hazel"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 3,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 1,
          "sensitivity": 2,
          "redness": 2,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 1,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 1,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      "kaolin": {
        "id": "I061",
        "key": "kaolin",
        "name": "Kaolin",
        "synonyms": [
          "White Clay"
        ],
        "type": "Arcilla",
        "scores": {
          "sebum": 4,
          "acne": 3,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 3,
          "sebumControl": 4,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Absorbente"
      },
      "bentonite": {
        "id": "I062",
        "key": "bentonite",
        "name": "Bentonite",
        "synonyms": [
          "Bentonite Clay"
        ],
        "type": "Arcilla",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 2,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 3,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Purificante"
      },
      "carbon_vegetal": {
        "id": "I063",
        "key": "carbon_vegetal",
        "name": "Carbón Vegetal",
        "synonyms": [
          "Charcoal"
        ],
        "type": "Mineral",
        "scores": {
          "sebum": 5,
          "acne": 4,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 0,
          "barrier": 0,
          "sensitivity": 1,
          "redness": 1,
          "antiAgeing": 0,
          "elasticity": 0,
          "antioxidant": 1,
          "soothing": 1,
          "repair": 0,
          "exfoliation": 2,
          "sebumControl": 5,
          "humectant": 0,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Detoxificante"
      },
      "zinc_pca": {
        "id": "I064",
        "key": "zinc_pca",
        "name": "Zinc PCA",
        "synonyms": [
          "Zinc PCA"
        ],
        "type": "Mineral",
        "scores": {
          "sebum": 5,
          "acne": 5,
          "pores": 4,
          "spots": 1,
          "glow": 2,
          "hydration": 1,
          "barrier": 2,
          "sensitivity": 3,
          "redness": 3,
          "antiAgeing": 1,
          "elasticity": 1,
          "antioxidant": 2,
          "soothing": 2,
          "repair": 2,
          "exfoliation": 0,
          "sebumControl": 5,
          "humectant": 2,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Seborregulador"
      },
      "sodium_pca": {
        "id": "I065",
        "key": "sodium_pca",
        "name": "Sodium PCA",
        "synonyms": [
          "PCA Sódico"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "sodium_lactate": {
        "id": "I066",
        "key": "sodium_lactate",
        "name": "Sodium Lactate",
        "synonyms": [
          "Lactato Sódico"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 1,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "urea": {
        "id": "I067",
        "key": "urea",
        "name": "Urea",
        "synonyms": [
          "Urea"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 2,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Hidratación intensa"
      },
      "trehalosa": {
        "id": "I068",
        "key": "trehalosa",
        "name": "Trehalosa",
        "synonyms": [
          "Trehalose"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Protección celular"
      },
      "betaina": {
        "id": "I069",
        "key": "betaina",
        "name": "Betaína",
        "synonyms": [
          "Betaine"
        ],
        "type": "Humectante",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 2,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Humectante"
      },
      "ectoina": {
        "id": "I070",
        "key": "ectoina",
        "name": "Ectoína",
        "synonyms": [
          "Ectoin"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 5,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 5,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Protector celular"
      },
      "bisabolol": {
        "id": "I071",
        "key": "bisabolol",
        "name": "Bisabolol",
        "synonyms": [
          "Alpha-Bisabolol"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 0,
          "acne": 1,
          "pores": 0,
          "spots": 2,
          "glow": 2,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 3,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Calmante"
      },
      "dipotassium_glycyrrhizate": {
        "id": "I072",
        "key": "dipotassium_glycyrrhizate",
        "name": "Dipotassium Glycyrrhizate",
        "synonyms": [
          "Regaliz Derivado"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 4,
          "glow": 3,
          "hydration": 2,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 4,
          "soothing": 5,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 2,
          "brightening": 5
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiinflamatorio"
      },
      "fitosfingosina": {
        "id": "I073",
        "key": "fitosfingosina",
        "name": "Fitosfingosina",
        "synonyms": [
          "Phytosphingosine"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 1,
          "acne": 3,
          "pores": 2,
          "spots": 1,
          "glow": 2,
          "hydration": 4,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 5,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 2,
          "soothing": 4,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 2,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Barrera cutánea"
      },
      "colesterol": {
        "id": "I074",
        "key": "colesterol",
        "name": "Colesterol",
        "synonyms": [
          "Cholesterol"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 1,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 1,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Reparador"
      },
      "escualeno": {
        "id": "I075",
        "key": "escualeno",
        "name": "Escualeno",
        "synonyms": [
          "Squalene"
        ],
        "type": "Lípido",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 5,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "jalea_real": {
        "id": "I076",
        "key": "jalea_real",
        "name": "Jalea Real",
        "synonyms": [
          "Royal Jelly"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 2,
          "pores": 1,
          "spots": 2,
          "glow": 3,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 5,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 2
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Prec.",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Nutritivo"
      },
      "soja_fermentada": {
        "id": "I077",
        "key": "soja_fermentada",
        "name": "Soja Fermentada",
        "synonyms": [
          "Soybean Ferment"
        ],
        "type": "Fermento",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 4,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Antiedad"
      },
      "extracto_de_soja": {
        "id": "I078",
        "key": "extracto_de_soja",
        "name": "Extracto de Soja",
        "synonyms": [
          "Soy Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 1,
          "acne": 1,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 3,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 3,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Antioxidante"
      },
      "extracto_de_arroz": {
        "id": "I079",
        "key": "extracto_de_arroz",
        "name": "Extracto de Arroz",
        "synonyms": [
          "Rice Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 4,
          "glow": 5,
          "hydration": 4,
          "barrier": 4,
          "sensitivity": 5,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 3,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 4
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐⭐",
        "primaryFunction": "Iluminador"
      },
      "extracto_de_judia_mungo": {
        "id": "I080",
        "key": "extracto_de_judia_mungo",
        "name": "Extracto de Judía Mungo",
        "synonyms": [
          "Mung Bean"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 3,
          "acne": 3,
          "pores": 2,
          "spots": 1,
          "glow": 2,
          "hydration": 3,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 4,
          "antiAgeing": 2,
          "elasticity": 2,
          "antioxidant": 3,
          "soothing": 4,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 3,
          "humectant": 3,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "⭐⭐⭐⭐",
        "primaryFunction": "Purificante"
      },
      "mucina_de_caracol": {
        "id": "I081",
        "key": "mucina_de_caracol",
        "name": "Mucina de Caracol",
        "synonyms": [
          "Snail Secretion Filtrate",
          "Snail Mucin",
          "Snail Mucus"
        ],
        "type": "Activo",
        "scores": {
          "sebum": 1,
          "acne": 3,
          "pores": 1,
          "spots": 3,
          "glow": 4,
          "hydration": 5,
          "barrier": 4,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 4,
          "elasticity": 4,
          "antioxidant": 3,
          "soothing": 3,
          "repair": 5,
          "exfoliation": 0,
          "sebumControl": 1,
          "humectant": 5,
          "brightening": 3
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Alta",
        "primaryFunction": "Regenerador e hidratante"
      },
      "aguacate": {
        "id": "I082",
        "key": "aguacate",
        "name": "Aguacate",
        "synonyms": [
          "Persea Gratissima Fruit Extract",
          "Avocado Extract"
        ],
        "type": "Extracto",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 1,
          "glow": 3,
          "hydration": 5,
          "barrier": 5,
          "sensitivity": 4,
          "redness": 3,
          "antiAgeing": 3,
          "elasticity": 4,
          "antioxidant": 4,
          "soothing": 3,
          "repair": 4,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 1
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Media",
        "primaryFunction": "Nutritivo y emoliente"
      },
      "arginina": {
        "id": "I083",
        "key": "arginina",
        "name": "Arginina",
        "synonyms": [
          "Arginine"
        ],
        "type": "Aminoácido",
        "scores": {
          "sebum": 0,
          "acne": 0,
          "pores": 0,
          "spots": 0,
          "glow": 2,
          "hydration": 4,
          "barrier": 3,
          "sensitivity": 4,
          "redness": 2,
          "antiAgeing": 2,
          "elasticity": 3,
          "antioxidant": 1,
          "soothing": 2,
          "repair": 3,
          "exfoliation": 0,
          "sebumControl": 0,
          "humectant": 4,
          "brightening": 0
        },
        "compatibility": {
          "retinol": "Sí",
          "vitaminC": "Sí",
          "aha": "Sí",
          "bha": "Sí"
        },
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "pregnancy": "Sí",
        "evidence": "Media",
        "primaryFunction": "Humectante y acondicionador"
      }
    },
    "ingredientAliases": {
      "niacinamida": "niacinamida",
      "vitamin_b3": "niacinamida",
      "centella_asiatica": "centella_asiatica",
      "cica": "centella_asiatica",
      "acido_hialuronico": "acido_hialuronico",
      "ha": "acido_hialuronico",
      "ceramidas": "ceramidas",
      "ceramide_np_ap_eop": "ceramidas",
      "pantenol": "pantenol",
      "provitamina_b5": "pantenol",
      "madecassoside": "madecassoside",
      "beta_glucano": "beta_glucano",
      "beta_glucan": "beta_glucano",
      "escualano": "escualano",
      "squalane": "escualano",
      "alantoina": "alantoina",
      "allantoin": "alantoina",
      "adenosina": "adenosina",
      "adenosine": "adenosina",
      "retinol": "retinol",
      "vitamin_a": "retinol",
      "retinal": "retinal",
      "retinaldehyde": "retinal",
      "bakuchiol": "bakuchiol",
      "vitamina_c": "vitamina_c",
      "ascorbic_acid": "vitamina_c",
      "vitamina_e": "vitamina_e",
      "tocopherol": "vitamina_e",
      "acido_azelaico": "acido_azelaico",
      "azelaic_acid": "acido_azelaico",
      "acido_tranexamico": "acido_tranexamico",
      "tranexamic_acid": "acido_tranexamico",
      "alfa_arbutina": "alfa_arbutina",
      "alpha_arbutin": "alfa_arbutina",
      "acido_salicilico": "acido_salicilico",
      "bha": "acido_salicilico",
      "acido_glicolico": "acido_glicolico",
      "glycolic_acid": "acido_glicolico",
      "acido_lactico": "acido_lactico",
      "lactic_acid": "acido_lactico",
      "gluconolactona": "gluconolactona",
      "pha": "gluconolactona",
      "acido_mandelico": "acido_mandelico",
      "mandelic_acid": "acido_mandelico",
      "acido_ferulico": "acido_ferulico",
      "ferulic_acid": "acido_ferulico",
      "cafeina": "cafeina",
      "caffeine": "cafeina",
      "peptidos": "peptidos",
      "peptides": "peptidos",
      "copper_peptides": "copper_peptides",
      "ghk_cu": "copper_peptides",
      "colageno_hidrolizado": "colageno_hidrolizado",
      "hydrolyzed_collagen": "colageno_hidrolizado",
      "elastina": "elastina",
      "elastin": "elastina",
      "egf": "egf",
      "epidermal_growth_factor": "egf",
      "bifida_ferment_lysate": "bifida_ferment_lysate",
      "bifida": "bifida_ferment_lysate",
      "galactomyces_ferment": "galactomyces_ferment",
      "galactomyces": "galactomyces_ferment",
      "saccharomyces_ferment": "saccharomyces_ferment",
      "saccharomyces": "saccharomyces_ferment",
      "lactobacillus_ferment": "lactobacillus_ferment",
      "probiotics": "lactobacillus_ferment",
      "propoleo": "propoleo",
      "propolis": "propoleo",
      "miel": "miel",
      "honey_extract": "miel",
      "aloe_vera": "aloe_vera",
      "aloe_barbadensis": "aloe_vera",
      "regaliz": "regaliz",
      "licorice_root": "regaliz",
      "ginseng": "ginseng",
      "panax_ginseng": "ginseng",
      "artemisa": "artemisa",
      "mugwort": "artemisa",
      "houttuynia_cordata": "houttuynia_cordata",
      "heartleaf": "houttuynia_cordata",
      "camellia_sinensis": "camellia_sinensis",
      "te_verde": "camellia_sinensis",
      "camellia_japonica": "camellia_japonica",
      "camelia": "camellia_japonica",
      "yuzu": "yuzu",
      "citrus_junos": "yuzu",
      "papaya": "papaya",
      "carica_papaya": "papaya",
      "granada": "granada",
      "punica_granatum": "granada",
      "espino_amarillo": "espino_amarillo",
      "sea_buckthorn": "espino_amarillo",
      "baobab": "baobab",
      "adansonia_digitata": "baobab",
      "aloe_ferment": "aloe_ferment",
      "fermented_aloe": "aloe_ferment",
      "arroz_fermentado": "arroz_fermentado",
      "rice_ferment": "arroz_fermentado",
      "aceite_de_jojoba": "aceite_de_jojoba",
      "jojoba_oil": "aceite_de_jojoba",
      "aceite_de_oliva": "aceite_de_oliva",
      "olive_oil": "aceite_de_oliva",
      "aceite_de_salvado_de_arroz": "aceite_de_salvado_de_arroz",
      "rice_bran_oil": "aceite_de_salvado_de_arroz",
      "aceite_de_baobab": "aceite_de_baobab",
      "baobab_oil": "aceite_de_baobab",
      "aceite_mct": "aceite_mct",
      "caprylic_capric_triglyceride": "aceite_mct",
      "calendula": "calendula",
      "calendula_officinalis": "calendula",
      "bambu": "bambu",
      "bamboo_extract": "bambu",
      "te_negro": "te_negro",
      "black_tea": "te_negro",
      "rosa_damascena": "rosa_damascena",
      "rose_damask": "rosa_damascena",
      "hamamelis": "hamamelis",
      "witch_hazel": "hamamelis",
      "kaolin": "kaolin",
      "white_clay": "kaolin",
      "bentonite": "bentonite",
      "bentonite_clay": "bentonite",
      "carbon_vegetal": "carbon_vegetal",
      "charcoal": "carbon_vegetal",
      "zinc_pca": "zinc_pca",
      "sodium_pca": "sodium_pca",
      "pca_sodico": "sodium_pca",
      "sodium_lactate": "sodium_lactate",
      "lactato_sodico": "sodium_lactate",
      "urea": "urea",
      "trehalosa": "trehalosa",
      "trehalose": "trehalosa",
      "betaina": "betaina",
      "betaine": "betaina",
      "ectoina": "ectoina",
      "ectoin": "ectoina",
      "bisabolol": "bisabolol",
      "alpha_bisabolol": "bisabolol",
      "dipotassium_glycyrrhizate": "dipotassium_glycyrrhizate",
      "regaliz_derivado": "dipotassium_glycyrrhizate",
      "fitosfingosina": "fitosfingosina",
      "phytosphingosine": "fitosfingosina",
      "colesterol": "colesterol",
      "cholesterol": "colesterol",
      "escualeno": "escualeno",
      "squalene": "escualeno",
      "jalea_real": "jalea_real",
      "royal_jelly": "jalea_real",
      "soja_fermentada": "soja_fermentada",
      "soybean_ferment": "soja_fermentada",
      "extracto_de_soja": "extracto_de_soja",
      "soy_extract": "extracto_de_soja",
      "extracto_de_arroz": "extracto_de_arroz",
      "rice_extract": "extracto_de_arroz",
      "extracto_de_judia_mungo": "extracto_de_judia_mungo",
      "mung_bean": "extracto_de_judia_mungo",
      "mucina_de_caracol": "mucina_de_caracol",
      "snail_secretion_filtrate": "mucina_de_caracol",
      "snail_mucin": "mucina_de_caracol",
      "snail_mucus": "mucina_de_caracol",
      "aguacate": "aguacate",
      "persea_gratissima_fruit_extract": "aguacate",
      "avocado_extract": "aguacate",
      "arginina": "arginina",
      "arginine": "arginina",
      "green_tea": "camellia_sinensis",
      "sodium_hyaluronate": "acido_hialuronico",
      "snail_mucin_extract": "mucina_de_caracol",
      "collagen": "colageno_hidrolizado",
      "l_ascorbic_acid": "vitamina_c",
      "tocopheryl_acetate": "vitamina_e",
      "arbutin": "alfa_arbutina"
    },
    "problems": [
      {
        "id": "PR001",
        "key": "acne_y_brotes",
        "name": "Acné y brotes",
        "description": "Presencia de granos, comedones o inflamación",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Grasa / Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Ácido Salicílico",
          "Heartleaf",
          "Té Verde",
          "Centella"
        ],
        "limitIngredients": [
          "Aceites muy pesados si empeoran la piel"
        ],
        "routineGoals": [
          "Reducir inflamación",
          "regular sebo",
          "prevenir marcas"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Exfoliante BHA",
          "Sérum",
          "Crema ligera",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir exfoliantes de forma progresiva"
      },
      {
        "id": "PR002",
        "key": "poros_dilatados",
        "name": "Poros dilatados",
        "description": "Poros visibles y exceso de sebo",
        "priority": "Alta",
        "commonSkinTypes": [
          "Grasa / Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA",
          "Té Verde"
        ],
        "limitIngredients": [
          "Productos muy oclusivos"
        ],
        "routineGoals": [
          "Regular sebo y mejorar textura"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Tónico",
          "Sérum",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La constancia es clave"
      },
      {
        "id": "PR003",
        "key": "manchas_e_hiperpigmentacion",
        "name": "Manchas e hiperpigmentación",
        "description": "Tono irregular o marcas post-acné",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Ácido Tranexámico",
          "Alfa-Arbutina",
          "Regaliz",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exfoliación excesiva sin SPF"
        ],
        "routineGoals": [
          "Unificar el tono"
        ],
        "recommendedSteps": [
          "Antioxidante",
          "Sérum",
          "Crema",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Protector solar obligatorio"
      },
      {
        "id": "PR004",
        "key": "piel_deshidratada",
        "name": "Piel deshidratada",
        "description": "Falta de agua y sensación de tirantez",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "routineGoals": [
          "Aumentar hidratación"
        ],
        "recommendedSteps": [
          "Tónico",
          "Sérum",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar sobre piel ligeramente húmeda"
      },
      {
        "id": "PR005",
        "key": "barrera_cutanea_danada",
        "name": "Barrera cutánea dañada",
        "description": "Sensibilidad, irritación o descamación",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Ceramidas",
          "Pantenol",
          "Centella",
          "Beta-Glucano",
          "Escualano"
        ],
        "limitIngredients": [
          "AHA/BHA fuertes y retinoides al inicio"
        ],
        "routineGoals": [
          "Reparar la barrera"
        ],
        "recommendedSteps": [
          "Limpiador suave",
          "Sérum reparador",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Simplificar la rutina"
      },
      {
        "id": "PR006",
        "key": "rojeces",
        "name": "Rojeces",
        "description": "Enrojecimiento persistente o reactivo",
        "priority": "Alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Madecassoside",
          "Aloe Vera",
          "Bisabolol",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Alcoholes secantes y exfoliación intensa"
        ],
        "routineGoals": [
          "Calmar e hidratar"
        ],
        "recommendedSteps": [
          "Tónico",
          "Sérum calmante",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Evitar agua muy caliente"
      },
      {
        "id": "PR007",
        "key": "arrugas_y_lineas_de_expresion",
        "name": "Arrugas y líneas de expresión",
        "description": "Pérdida de firmeza y elasticidad",
        "priority": "Alta",
        "commonSkinTypes": [
          "Normal / Seca"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Retinol",
          "Péptidos",
          "Adenosina",
          "Colágeno",
          "Ginseng"
        ],
        "limitIngredients": [
          "Sobreexfoliación"
        ],
        "routineGoals": [
          "Estimular renovación y firmeza"
        ],
        "recommendedSteps": [
          "Sérum",
          "Contorno",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Retinoides preferiblemente por la noche"
      },
      {
        "id": "PR008",
        "key": "perdida_de_firmeza",
        "name": "Pérdida de firmeza",
        "description": "Piel menos elástica",
        "priority": "Media",
        "commonSkinTypes": [
          "Normal / Madura"
        ],
        "recommendedIngredients": [
          "Péptidos",
          "Colágeno",
          "Adenosina",
          "EGF"
        ],
        "limitIngredients": [
          "—"
        ],
        "routineGoals": [
          "Mejorar elasticidad"
        ],
        "recommendedSteps": [
          "Sérum y Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar con antioxidantes"
      },
      {
        "id": "PR009",
        "key": "exceso_de_grasa",
        "name": "Exceso de grasa",
        "description": "Brillo constante",
        "priority": "Alta",
        "commonSkinTypes": [
          "Grasa"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Té Verde",
          "BHA"
        ],
        "limitIngredients": [
          "Aceites pesados"
        ],
        "routineGoals": [
          "Equilibrar producción de sebo"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Sérum",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar totalmente la hidratación"
      },
      {
        "id": "PR010",
        "key": "piel_apagada",
        "name": "Piel apagada",
        "description": "Falta de luminosidad",
        "priority": "Media",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Yuzu",
          "Arroz",
          "Fermentos",
          "Papaya"
        ],
        "limitIngredients": [
          "Tabaco",
          "falta de SPF"
        ],
        "routineGoals": [
          "Aportar glow"
        ],
        "recommendedSteps": [
          "Exfoliante suave",
          "Sérum antioxidante",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Mantener exfoliación moderada"
      },
      {
        "id": "PR011",
        "key": "sensibilidad",
        "name": "Sensibilidad",
        "description": "Piel reactiva",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Ceramidas",
          "Beta-Glucano",
          "Pantenol"
        ],
        "limitIngredients": [
          "Perfumes intensos y exfoliantes fuertes"
        ],
        "routineGoals": [
          "Reducir irritación"
        ],
        "recommendedSteps": [
          "Rutina mínima"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir activos poco a poco"
      },
      {
        "id": "PR012",
        "key": "ojeras_y_bolsas",
        "name": "Ojeras y bolsas",
        "description": "Contorno congestionado",
        "priority": "Media",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Cafeína",
          "Péptidos",
          "Adenosina",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Fricción excesiva"
        ],
        "routineGoals": [
          "Descongestionar e iluminar"
        ],
        "recommendedSteps": [
          "Contorno de ojos"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar con suaves toques"
      }
    ],
    "problemsById": {
      "PR001": {
        "id": "PR001",
        "key": "acne_y_brotes",
        "name": "Acné y brotes",
        "description": "Presencia de granos, comedones o inflamación",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Grasa / Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Ácido Salicílico",
          "Heartleaf",
          "Té Verde",
          "Centella"
        ],
        "limitIngredients": [
          "Aceites muy pesados si empeoran la piel"
        ],
        "routineGoals": [
          "Reducir inflamación",
          "regular sebo",
          "prevenir marcas"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Exfoliante BHA",
          "Sérum",
          "Crema ligera",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir exfoliantes de forma progresiva"
      },
      "PR002": {
        "id": "PR002",
        "key": "poros_dilatados",
        "name": "Poros dilatados",
        "description": "Poros visibles y exceso de sebo",
        "priority": "Alta",
        "commonSkinTypes": [
          "Grasa / Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA",
          "Té Verde"
        ],
        "limitIngredients": [
          "Productos muy oclusivos"
        ],
        "routineGoals": [
          "Regular sebo y mejorar textura"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Tónico",
          "Sérum",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La constancia es clave"
      },
      "PR003": {
        "id": "PR003",
        "key": "manchas_e_hiperpigmentacion",
        "name": "Manchas e hiperpigmentación",
        "description": "Tono irregular o marcas post-acné",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Ácido Tranexámico",
          "Alfa-Arbutina",
          "Regaliz",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exfoliación excesiva sin SPF"
        ],
        "routineGoals": [
          "Unificar el tono"
        ],
        "recommendedSteps": [
          "Antioxidante",
          "Sérum",
          "Crema",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Protector solar obligatorio"
      },
      "PR004": {
        "id": "PR004",
        "key": "piel_deshidratada",
        "name": "Piel deshidratada",
        "description": "Falta de agua y sensación de tirantez",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "routineGoals": [
          "Aumentar hidratación"
        ],
        "recommendedSteps": [
          "Tónico",
          "Sérum",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar sobre piel ligeramente húmeda"
      },
      "PR005": {
        "id": "PR005",
        "key": "barrera_cutanea_danada",
        "name": "Barrera cutánea dañada",
        "description": "Sensibilidad, irritación o descamación",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Ceramidas",
          "Pantenol",
          "Centella",
          "Beta-Glucano",
          "Escualano"
        ],
        "limitIngredients": [
          "AHA/BHA fuertes y retinoides al inicio"
        ],
        "routineGoals": [
          "Reparar la barrera"
        ],
        "recommendedSteps": [
          "Limpiador suave",
          "Sérum reparador",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Simplificar la rutina"
      },
      "PR006": {
        "id": "PR006",
        "key": "rojeces",
        "name": "Rojeces",
        "description": "Enrojecimiento persistente o reactivo",
        "priority": "Alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Madecassoside",
          "Aloe Vera",
          "Bisabolol",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Alcoholes secantes y exfoliación intensa"
        ],
        "routineGoals": [
          "Calmar e hidratar"
        ],
        "recommendedSteps": [
          "Tónico",
          "Sérum calmante",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Evitar agua muy caliente"
      },
      "PR007": {
        "id": "PR007",
        "key": "arrugas_y_lineas_de_expresion",
        "name": "Arrugas y líneas de expresión",
        "description": "Pérdida de firmeza y elasticidad",
        "priority": "Alta",
        "commonSkinTypes": [
          "Normal / Seca"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Retinol",
          "Péptidos",
          "Adenosina",
          "Colágeno",
          "Ginseng"
        ],
        "limitIngredients": [
          "Sobreexfoliación"
        ],
        "routineGoals": [
          "Estimular renovación y firmeza"
        ],
        "recommendedSteps": [
          "Sérum",
          "Contorno",
          "Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Retinoides preferiblemente por la noche"
      },
      "PR008": {
        "id": "PR008",
        "key": "perdida_de_firmeza",
        "name": "Pérdida de firmeza",
        "description": "Piel menos elástica",
        "priority": "Media",
        "commonSkinTypes": [
          "Normal / Madura"
        ],
        "recommendedIngredients": [
          "Péptidos",
          "Colágeno",
          "Adenosina",
          "EGF"
        ],
        "limitIngredients": [
          "—"
        ],
        "routineGoals": [
          "Mejorar elasticidad"
        ],
        "recommendedSteps": [
          "Sérum y Crema"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar con antioxidantes"
      },
      "PR009": {
        "id": "PR009",
        "key": "exceso_de_grasa",
        "name": "Exceso de grasa",
        "description": "Brillo constante",
        "priority": "Alta",
        "commonSkinTypes": [
          "Grasa"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Té Verde",
          "BHA"
        ],
        "limitIngredients": [
          "Aceites pesados"
        ],
        "routineGoals": [
          "Equilibrar producción de sebo"
        ],
        "recommendedSteps": [
          "Limpieza",
          "Sérum",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar totalmente la hidratación"
      },
      "PR010": {
        "id": "PR010",
        "key": "piel_apagada",
        "name": "Piel apagada",
        "description": "Falta de luminosidad",
        "priority": "Media",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Yuzu",
          "Arroz",
          "Fermentos",
          "Papaya"
        ],
        "limitIngredients": [
          "Tabaco",
          "falta de SPF"
        ],
        "routineGoals": [
          "Aportar glow"
        ],
        "recommendedSteps": [
          "Exfoliante suave",
          "Sérum antioxidante",
          "SPF"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Mantener exfoliación moderada"
      },
      "PR011": {
        "id": "PR011",
        "key": "sensibilidad",
        "name": "Sensibilidad",
        "description": "Piel reactiva",
        "priority": "Muy alta",
        "commonSkinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Ceramidas",
          "Beta-Glucano",
          "Pantenol"
        ],
        "limitIngredients": [
          "Perfumes intensos y exfoliantes fuertes"
        ],
        "routineGoals": [
          "Reducir irritación"
        ],
        "recommendedSteps": [
          "Rutina mínima"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir activos poco a poco"
      },
      "PR012": {
        "id": "PR012",
        "key": "ojeras_y_bolsas",
        "name": "Ojeras y bolsas",
        "description": "Contorno congestionado",
        "priority": "Media",
        "commonSkinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Cafeína",
          "Péptidos",
          "Adenosina",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Fricción excesiva"
        ],
        "routineGoals": [
          "Descongestionar e iluminar"
        ],
        "recommendedSteps": [
          "Contorno de ojos"
        ],
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar con suaves toques"
      }
    },
    "skinTypes": [
      {
        "id": "TP001",
        "key": "normal",
        "name": "Piel normal",
        "description": "Equilibrada, sin exceso de grasa ni sequedad.",
        "identification": "Textura uniforme, pocos poros visibles, sin brillo excesivo.",
        "sebum": "Media",
        "hydration": "Alta",
        "sensitivity": "Baja",
        "commonProblems": [
          "Deshidratación puntual"
        ],
        "primaryGoals": [
          "Mantener equilibrio y prevenir envejecimiento"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Niacinamida",
          "Vitamina C",
          "Ceramidas"
        ],
        "limitIngredients": [
          "Ninguno en particular"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Adaptar la rutina según la estación."
      },
      {
        "id": "TP002",
        "key": "seca",
        "name": "Piel seca",
        "description": "Produce poco sebo y suele sentirse tirante.",
        "identification": "Tirantez, descamación, falta de luminosidad.",
        "sebum": "Baja",
        "hydration": "Baja",
        "sensitivity": "Media",
        "commonProblems": [
          "Deshidratación",
          "barrera dañada"
        ],
        "primaryGoals": [
          "Nutrir",
          "hidratar y reparar"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Ceramidas",
          "Escualano",
          "Pantenol",
          "Beta-Glucano"
        ],
        "limitIngredients": [
          "Exfoliantes agresivos y limpiadores muy espumosos"
        ],
        "recommendedRoutine": "Limpieza suave → Tónico → Sérum → Crema rica → SPF",
        "exfoliationFrequency": "1 vez/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Priorizar productos nutritivos."
      },
      {
        "id": "TP003",
        "key": "grasa",
        "name": "Piel grasa",
        "description": "Produce exceso de sebo durante todo el día.",
        "identification": "Brillos, poros visibles, tendencia acneica.",
        "sebum": "Alta",
        "hydration": "Media",
        "sensitivity": "Baja",
        "commonProblems": [
          "Acné",
          "poros",
          "exceso de grasa"
        ],
        "primaryGoals": [
          "Regular el sebo sin deshidratar"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA",
          "Té Verde",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Aceites muy pesados si resultan comedogénicos"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Crema ligera → SPF",
        "exfoliationFrequency": "2-3 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar la hidratación."
      },
      {
        "id": "TP004",
        "key": "mixta",
        "name": "Piel mixta",
        "description": "Zona T grasa y mejillas normales o secas.",
        "identification": "Brillo en frente, nariz y barbilla.",
        "sebum": "Media/Alta",
        "hydration": "Media",
        "sensitivity": "Media",
        "commonProblems": [
          "Poros y deshidratación localizada"
        ],
        "primaryGoals": [
          "Equilibrar las distintas zonas"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Ácido Hialurónico",
          "Té Verde"
        ],
        "limitIngredients": [
          "Exceso de exfoliación"
        ],
        "recommendedRoutine": "Limpieza → Tónico → Sérum → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Puede requerir productos distintos por zonas."
      },
      {
        "id": "TP005",
        "key": "sensible",
        "name": "Piel sensible",
        "description": "Reacciona fácilmente a factores externos.",
        "identification": "Rojeces, picor o irritación.",
        "sebum": "Variable",
        "hydration": "Media",
        "sensitivity": "Muy alta",
        "commonProblems": [
          "Rojeces",
          "barrera dañada"
        ],
        "primaryGoals": [
          "Calmar y fortalecer la barrera"
        ],
        "recommendedIngredients": [
          "Centella",
          "Ceramidas",
          "Pantenol",
          "Beta-Glucano",
          "Aloe Vera"
        ],
        "limitIngredients": [
          "Perfumes intensos",
          "alcoholes secantes",
          "exfoliación excesiva"
        ],
        "recommendedRoutine": "Limpieza suave → Sérum calmante → Crema → SPF",
        "exfoliationFrequency": "Cada 10-15 días",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir activos poco a poco."
      },
      {
        "id": "TP006",
        "key": "deshidratada",
        "name": "Piel deshidratada",
        "description": "Estado temporal de falta de agua.",
        "identification": "Puede aparecer en cualquier tipo de piel.",
        "sebum": "Variable",
        "hydration": "Muy baja",
        "sensitivity": "Media",
        "commonProblems": [
          "Tirantez",
          "líneas finas"
        ],
        "primaryGoals": [
          "Aumentar el contenido de agua"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "recommendedRoutine": "Tónico → Sérum → Crema → SPF",
        "exfoliationFrequency": "1 vez/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No confundir con piel seca."
      },
      {
        "id": "TP007",
        "key": "madura",
        "name": "Piel madura",
        "description": "Pérdida progresiva de elasticidad y firmeza.",
        "identification": "Arrugas, menor densidad y luminosidad.",
        "sebum": "Media/Baja",
        "hydration": "Media",
        "sensitivity": "Media",
        "commonProblems": [
          "Arrugas",
          "manchas",
          "pérdida de firmeza"
        ],
        "primaryGoals": [
          "Estimular colágeno y proteger frente a la oxidación"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Péptidos",
          "Adenosina",
          "Ginseng",
          "Vitamina C",
          "Colágeno"
        ],
        "limitIngredients": [
          "Exceso de exfoliación y rutinas agresivas"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Contorno → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar antioxidantes por el día y retinoides por la noche."
      }
    ],
    "skinTypesByKey": {
      "normal": {
        "id": "TP001",
        "key": "normal",
        "name": "Piel normal",
        "description": "Equilibrada, sin exceso de grasa ni sequedad.",
        "identification": "Textura uniforme, pocos poros visibles, sin brillo excesivo.",
        "sebum": "Media",
        "hydration": "Alta",
        "sensitivity": "Baja",
        "commonProblems": [
          "Deshidratación puntual"
        ],
        "primaryGoals": [
          "Mantener equilibrio y prevenir envejecimiento"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Niacinamida",
          "Vitamina C",
          "Ceramidas"
        ],
        "limitIngredients": [
          "Ninguno en particular"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Adaptar la rutina según la estación."
      },
      "seca": {
        "id": "TP002",
        "key": "seca",
        "name": "Piel seca",
        "description": "Produce poco sebo y suele sentirse tirante.",
        "identification": "Tirantez, descamación, falta de luminosidad.",
        "sebum": "Baja",
        "hydration": "Baja",
        "sensitivity": "Media",
        "commonProblems": [
          "Deshidratación",
          "barrera dañada"
        ],
        "primaryGoals": [
          "Nutrir",
          "hidratar y reparar"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Ceramidas",
          "Escualano",
          "Pantenol",
          "Beta-Glucano"
        ],
        "limitIngredients": [
          "Exfoliantes agresivos y limpiadores muy espumosos"
        ],
        "recommendedRoutine": "Limpieza suave → Tónico → Sérum → Crema rica → SPF",
        "exfoliationFrequency": "1 vez/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Priorizar productos nutritivos."
      },
      "grasa": {
        "id": "TP003",
        "key": "grasa",
        "name": "Piel grasa",
        "description": "Produce exceso de sebo durante todo el día.",
        "identification": "Brillos, poros visibles, tendencia acneica.",
        "sebum": "Alta",
        "hydration": "Media",
        "sensitivity": "Baja",
        "commonProblems": [
          "Acné",
          "poros",
          "exceso de grasa"
        ],
        "primaryGoals": [
          "Regular el sebo sin deshidratar"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA",
          "Té Verde",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Aceites muy pesados si resultan comedogénicos"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Crema ligera → SPF",
        "exfoliationFrequency": "2-3 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar la hidratación."
      },
      "mixta": {
        "id": "TP004",
        "key": "mixta",
        "name": "Piel mixta",
        "description": "Zona T grasa y mejillas normales o secas.",
        "identification": "Brillo en frente, nariz y barbilla.",
        "sebum": "Media/Alta",
        "hydration": "Media",
        "sensitivity": "Media",
        "commonProblems": [
          "Poros y deshidratación localizada"
        ],
        "primaryGoals": [
          "Equilibrar las distintas zonas"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Ácido Hialurónico",
          "Té Verde"
        ],
        "limitIngredients": [
          "Exceso de exfoliación"
        ],
        "recommendedRoutine": "Limpieza → Tónico → Sérum → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Puede requerir productos distintos por zonas."
      },
      "sensible": {
        "id": "TP005",
        "key": "sensible",
        "name": "Piel sensible",
        "description": "Reacciona fácilmente a factores externos.",
        "identification": "Rojeces, picor o irritación.",
        "sebum": "Variable",
        "hydration": "Media",
        "sensitivity": "Muy alta",
        "commonProblems": [
          "Rojeces",
          "barrera dañada"
        ],
        "primaryGoals": [
          "Calmar y fortalecer la barrera"
        ],
        "recommendedIngredients": [
          "Centella",
          "Ceramidas",
          "Pantenol",
          "Beta-Glucano",
          "Aloe Vera"
        ],
        "limitIngredients": [
          "Perfumes intensos",
          "alcoholes secantes",
          "exfoliación excesiva"
        ],
        "recommendedRoutine": "Limpieza suave → Sérum calmante → Crema → SPF",
        "exfoliationFrequency": "Cada 10-15 días",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir activos poco a poco."
      },
      "deshidratada": {
        "id": "TP006",
        "key": "deshidratada",
        "name": "Piel deshidratada",
        "description": "Estado temporal de falta de agua.",
        "identification": "Puede aparecer en cualquier tipo de piel.",
        "sebum": "Variable",
        "hydration": "Muy baja",
        "sensitivity": "Media",
        "commonProblems": [
          "Tirantez",
          "líneas finas"
        ],
        "primaryGoals": [
          "Aumentar el contenido de agua"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "recommendedRoutine": "Tónico → Sérum → Crema → SPF",
        "exfoliationFrequency": "1 vez/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No confundir con piel seca."
      },
      "madura": {
        "id": "TP007",
        "key": "madura",
        "name": "Piel madura",
        "description": "Pérdida progresiva de elasticidad y firmeza.",
        "identification": "Arrugas, menor densidad y luminosidad.",
        "sebum": "Media/Baja",
        "hydration": "Media",
        "sensitivity": "Media",
        "commonProblems": [
          "Arrugas",
          "manchas",
          "pérdida de firmeza"
        ],
        "primaryGoals": [
          "Estimular colágeno y proteger frente a la oxidación"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Péptidos",
          "Adenosina",
          "Ginseng",
          "Vitamina C",
          "Colágeno"
        ],
        "limitIngredients": [
          "Exceso de exfoliación y rutinas agresivas"
        ],
        "recommendedRoutine": "Limpieza → Sérum → Contorno → Crema → SPF",
        "exfoliationFrequency": "1-2 veces/semana",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar antioxidantes por el día y retinoides por la noche."
      }
    },
    "objectives": [
      {
        "id": "OBJ001",
        "key": "controlar_el_acne",
        "name": "Controlar el acné",
        "description": "Reducir brotes, inflamación y prevenir nuevas imperfecciones.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Acné",
          "exceso de grasa"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Ácido Salicílico",
          "Heartleaf",
          "Té Verde"
        ],
        "limitIngredients": [
          "Aceites pesados si resultan comedogénicos"
        ],
        "keySteps": [
          "Limpieza",
          "Exfoliante BHA",
          "Sérum",
          "Crema ligera",
          "SPF"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir exfoliantes progresivamente."
      },
      {
        "id": "OBJ002",
        "key": "reducir_poros",
        "name": "Reducir poros",
        "description": "Mejorar el aspecto de los poros visibles.",
        "priority": "Alta",
        "relatedProblems": [
          "Poros dilatados"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA"
        ],
        "limitIngredients": [
          "Productos oclusivos"
        ],
        "keySteps": [
          "Limpieza",
          "Tónico",
          "Sérum",
          "SPF"
        ],
        "estimatedTime": "6-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La constancia es fundamental."
      },
      {
        "id": "OBJ003",
        "key": "hidratar_la_piel",
        "name": "Hidratar la piel",
        "description": "Aumentar el contenido de agua en la piel.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Deshidratación"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "keySteps": [
          "Tónico",
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "2-4 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar humectantes sobre piel ligeramente húmeda."
      },
      {
        "id": "OBJ004",
        "key": "reparar_la_barrera",
        "name": "Reparar la barrera",
        "description": "Restaurar la función protectora de la piel.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Barrera dañada"
        ],
        "skinTypes": [
          "Sensible",
          "Seca"
        ],
        "recommendedIngredients": [
          "Ceramidas",
          "Pantenol",
          "Centella",
          "Beta-Glucano",
          "Escualano"
        ],
        "limitIngredients": [
          "Retinoides y ácidos fuertes al inicio"
        ],
        "keySteps": [
          "Limpieza suave",
          "Sérum reparador",
          "Crema"
        ],
        "estimatedTime": "3-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Reducir temporalmente los activos fuertes."
      },
      {
        "id": "OBJ005",
        "key": "reducir_manchas",
        "name": "Reducir manchas",
        "description": "Mejorar la hiperpigmentación y unificar el tono.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Manchas"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Ácido Tranexámico",
          "Alfa-Arbutina",
          "Regaliz",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exposición solar sin SPF"
        ],
        "keySteps": [
          "Sérum antioxidante",
          "Crema",
          "SPF"
        ],
        "estimatedTime": "8-12 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "El protector solar es imprescindible."
      },
      {
        "id": "OBJ006",
        "key": "calmar_rojeces",
        "name": "Calmar rojeces",
        "description": "Reducir irritación y enrojecimiento.",
        "priority": "Alta",
        "relatedProblems": [
          "Rojeces"
        ],
        "skinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Madecassoside",
          "Aloe Vera",
          "Bisabolol",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Alcoholes secantes"
        ],
        "keySteps": [
          "Tónico calmante",
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "2-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Evitar agua muy caliente."
      },
      {
        "id": "OBJ007",
        "key": "mejorar_firmeza",
        "name": "Mejorar firmeza",
        "description": "Aumentar la elasticidad de la piel.",
        "priority": "Alta",
        "relatedProblems": [
          "Pérdida de firmeza"
        ],
        "skinTypes": [
          "Madura"
        ],
        "recommendedIngredients": [
          "Péptidos",
          "Colágeno",
          "Adenosina",
          "EGF"
        ],
        "limitIngredients": [
          "Rutinas agresivas"
        ],
        "keySteps": [
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "8-12 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar con antioxidantes."
      },
      {
        "id": "OBJ008",
        "key": "reducir_arrugas",
        "name": "Reducir arrugas",
        "description": "Disminuir líneas de expresión y arrugas.",
        "priority": "Alta",
        "relatedProblems": [
          "Arrugas"
        ],
        "skinTypes": [
          "Madura"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Retinol",
          "Adenosina",
          "Péptidos"
        ],
        "limitIngredients": [
          "Sobreexfoliación"
        ],
        "keySteps": [
          "Sérum",
          "Contorno",
          "Crema"
        ],
        "estimatedTime": "8-16 semanas",
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "notes": "Retinoides preferentemente por la noche."
      },
      {
        "id": "OBJ009",
        "key": "conseguir_efecto_glow",
        "name": "Conseguir efecto glow",
        "description": "Aumentar la luminosidad natural de la piel.",
        "priority": "Media",
        "relatedProblems": [
          "Piel apagada"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Yuzu",
          "Arroz",
          "Fermentos",
          "Papaya"
        ],
        "limitIngredients": [
          "Tabaco y exceso de exfoliación"
        ],
        "keySteps": [
          "Exfoliante suave",
          "Sérum antioxidante",
          "SPF"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La hidratación influye directamente."
      },
      {
        "id": "OBJ010",
        "key": "controlar_el_exceso_de_grasa",
        "name": "Controlar el exceso de grasa",
        "description": "Reducir brillos sin deshidratar.",
        "priority": "Alta",
        "relatedProblems": [
          "Exceso de sebo"
        ],
        "skinTypes": [
          "Grasa"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Té Verde"
        ],
        "limitIngredients": [
          "Productos muy oclusivos"
        ],
        "keySteps": [
          "Limpieza",
          "Sérum",
          "Crema ligera"
        ],
        "estimatedTime": "4-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar completamente los lípidos."
      },
      {
        "id": "OBJ011",
        "key": "reducir_ojeras",
        "name": "Reducir ojeras",
        "description": "Mejorar el tono oscuro del contorno de ojos.",
        "priority": "Media",
        "relatedProblems": [
          "Ojeras"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Cafeína",
          "Adenosina"
        ],
        "limitIngredients": [
          "Frotar la zona"
        ],
        "keySteps": [
          "Contorno de ojos"
        ],
        "estimatedTime": "6-10 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar con el dedo anular."
      },
      {
        "id": "OBJ012",
        "key": "reducir_bolsas",
        "name": "Reducir bolsas",
        "description": "Disminuir la hinchazón del contorno.",
        "priority": "Media",
        "relatedProblems": [
          "Bolsas"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Cafeína",
          "Péptidos"
        ],
        "limitIngredients": [
          "Exceso de sal y falta de descanso"
        ],
        "keySteps": [
          "Contorno de ojos"
        ],
        "estimatedTime": "2-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Conservar el producto en frío puede potenciar el efecto."
      },
      {
        "id": "OBJ013",
        "key": "prevenir_el_envejecimiento",
        "name": "Prevenir el envejecimiento",
        "description": "Mantener una piel sana a largo plazo.",
        "priority": "Alta",
        "relatedProblems": [
          "Prevención"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Retinal",
          "Péptidos",
          "Antioxidantes"
        ],
        "limitIngredients": [
          "Exposición solar sin SPF"
        ],
        "keySteps": [
          "Sérum",
          "Crema",
          "Protector Solar"
        ],
        "estimatedTime": "Continuo",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La protección solar diaria es la clave."
      },
      {
        "id": "OBJ014",
        "key": "mejorar_textura",
        "name": "Mejorar textura",
        "description": "Suavizar la superficie de la piel.",
        "priority": "Media",
        "relatedProblems": [
          "Textura irregular"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "AHA",
          "BHA",
          "PHA",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exfoliación excesiva"
        ],
        "keySteps": [
          "Exfoliante",
          "Sérum"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Alternar exfoliación química y días de descanso."
      },
      {
        "id": "OBJ015",
        "key": "reducir_puntos_negros",
        "name": "Reducir puntos negros",
        "description": "Limpiar los poros y prevenir obstrucciones.",
        "priority": "Alta",
        "relatedProblems": [
          "Puntos negros"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Ácido Salicílico",
          "Niacinamida",
          "Zinc PCA"
        ],
        "limitIngredients": [
          "Productos muy grasos"
        ],
        "keySteps": [
          "Limpieza",
          "Exfoliante BHA"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No manipular manualmente los comedones."
      }
    ],
    "objectivesById": {
      "OBJ001": {
        "id": "OBJ001",
        "key": "controlar_el_acne",
        "name": "Controlar el acné",
        "description": "Reducir brotes, inflamación y prevenir nuevas imperfecciones.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Acné",
          "exceso de grasa"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Ácido Salicílico",
          "Heartleaf",
          "Té Verde"
        ],
        "limitIngredients": [
          "Aceites pesados si resultan comedogénicos"
        ],
        "keySteps": [
          "Limpieza",
          "Exfoliante BHA",
          "Sérum",
          "Crema ligera",
          "SPF"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Introducir exfoliantes progresivamente."
      },
      "OBJ002": {
        "id": "OBJ002",
        "key": "reducir_poros",
        "name": "Reducir poros",
        "description": "Mejorar el aspecto de los poros visibles.",
        "priority": "Alta",
        "relatedProblems": [
          "Poros dilatados"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "BHA"
        ],
        "limitIngredients": [
          "Productos oclusivos"
        ],
        "keySteps": [
          "Limpieza",
          "Tónico",
          "Sérum",
          "SPF"
        ],
        "estimatedTime": "6-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La constancia es fundamental."
      },
      "OBJ003": {
        "id": "OBJ003",
        "key": "hidratar_la_piel",
        "name": "Hidratar la piel",
        "description": "Aumentar el contenido de agua en la piel.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Deshidratación"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Ácido Hialurónico",
          "Betaína",
          "Trehalosa",
          "Pantenol"
        ],
        "limitIngredients": [
          "Limpiadores agresivos"
        ],
        "keySteps": [
          "Tónico",
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "2-4 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar humectantes sobre piel ligeramente húmeda."
      },
      "OBJ004": {
        "id": "OBJ004",
        "key": "reparar_la_barrera",
        "name": "Reparar la barrera",
        "description": "Restaurar la función protectora de la piel.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Barrera dañada"
        ],
        "skinTypes": [
          "Sensible",
          "Seca"
        ],
        "recommendedIngredients": [
          "Ceramidas",
          "Pantenol",
          "Centella",
          "Beta-Glucano",
          "Escualano"
        ],
        "limitIngredients": [
          "Retinoides y ácidos fuertes al inicio"
        ],
        "keySteps": [
          "Limpieza suave",
          "Sérum reparador",
          "Crema"
        ],
        "estimatedTime": "3-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Reducir temporalmente los activos fuertes."
      },
      "OBJ005": {
        "id": "OBJ005",
        "key": "reducir_manchas",
        "name": "Reducir manchas",
        "description": "Mejorar la hiperpigmentación y unificar el tono.",
        "priority": "Muy alta",
        "relatedProblems": [
          "Manchas"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Ácido Tranexámico",
          "Alfa-Arbutina",
          "Regaliz",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exposición solar sin SPF"
        ],
        "keySteps": [
          "Sérum antioxidante",
          "Crema",
          "SPF"
        ],
        "estimatedTime": "8-12 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "El protector solar es imprescindible."
      },
      "OBJ006": {
        "id": "OBJ006",
        "key": "calmar_rojeces",
        "name": "Calmar rojeces",
        "description": "Reducir irritación y enrojecimiento.",
        "priority": "Alta",
        "relatedProblems": [
          "Rojeces"
        ],
        "skinTypes": [
          "Sensible"
        ],
        "recommendedIngredients": [
          "Centella",
          "Madecassoside",
          "Aloe Vera",
          "Bisabolol",
          "Heartleaf"
        ],
        "limitIngredients": [
          "Alcoholes secantes"
        ],
        "keySteps": [
          "Tónico calmante",
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "2-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Evitar agua muy caliente."
      },
      "OBJ007": {
        "id": "OBJ007",
        "key": "mejorar_firmeza",
        "name": "Mejorar firmeza",
        "description": "Aumentar la elasticidad de la piel.",
        "priority": "Alta",
        "relatedProblems": [
          "Pérdida de firmeza"
        ],
        "skinTypes": [
          "Madura"
        ],
        "recommendedIngredients": [
          "Péptidos",
          "Colágeno",
          "Adenosina",
          "EGF"
        ],
        "limitIngredients": [
          "Rutinas agresivas"
        ],
        "keySteps": [
          "Sérum",
          "Crema"
        ],
        "estimatedTime": "8-12 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Combinar con antioxidantes."
      },
      "OBJ008": {
        "id": "OBJ008",
        "key": "reducir_arrugas",
        "name": "Reducir arrugas",
        "description": "Disminuir líneas de expresión y arrugas.",
        "priority": "Alta",
        "relatedProblems": [
          "Arrugas"
        ],
        "skinTypes": [
          "Madura"
        ],
        "recommendedIngredients": [
          "Retinal",
          "Retinol",
          "Adenosina",
          "Péptidos"
        ],
        "limitIngredients": [
          "Sobreexfoliación"
        ],
        "keySteps": [
          "Sérum",
          "Contorno",
          "Crema"
        ],
        "estimatedTime": "8-16 semanas",
        "use": {
          "am": "No",
          "pm": "Sí"
        },
        "notes": "Retinoides preferentemente por la noche."
      },
      "OBJ009": {
        "id": "OBJ009",
        "key": "conseguir_efecto_glow",
        "name": "Conseguir efecto glow",
        "description": "Aumentar la luminosidad natural de la piel.",
        "priority": "Media",
        "relatedProblems": [
          "Piel apagada"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Yuzu",
          "Arroz",
          "Fermentos",
          "Papaya"
        ],
        "limitIngredients": [
          "Tabaco y exceso de exfoliación"
        ],
        "keySteps": [
          "Exfoliante suave",
          "Sérum antioxidante",
          "SPF"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La hidratación influye directamente."
      },
      "OBJ010": {
        "id": "OBJ010",
        "key": "controlar_el_exceso_de_grasa",
        "name": "Controlar el exceso de grasa",
        "description": "Reducir brillos sin deshidratar.",
        "priority": "Alta",
        "relatedProblems": [
          "Exceso de sebo"
        ],
        "skinTypes": [
          "Grasa"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Zinc PCA",
          "Té Verde"
        ],
        "limitIngredients": [
          "Productos muy oclusivos"
        ],
        "keySteps": [
          "Limpieza",
          "Sérum",
          "Crema ligera"
        ],
        "estimatedTime": "4-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No eliminar completamente los lípidos."
      },
      "OBJ011": {
        "id": "OBJ011",
        "key": "reducir_ojeras",
        "name": "Reducir ojeras",
        "description": "Mejorar el tono oscuro del contorno de ojos.",
        "priority": "Media",
        "relatedProblems": [
          "Ojeras"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Niacinamida",
          "Cafeína",
          "Adenosina"
        ],
        "limitIngredients": [
          "Frotar la zona"
        ],
        "keySteps": [
          "Contorno de ojos"
        ],
        "estimatedTime": "6-10 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Aplicar con el dedo anular."
      },
      "OBJ012": {
        "id": "OBJ012",
        "key": "reducir_bolsas",
        "name": "Reducir bolsas",
        "description": "Disminuir la hinchazón del contorno.",
        "priority": "Media",
        "relatedProblems": [
          "Bolsas"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Cafeína",
          "Péptidos"
        ],
        "limitIngredients": [
          "Exceso de sal y falta de descanso"
        ],
        "keySteps": [
          "Contorno de ojos"
        ],
        "estimatedTime": "2-6 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Conservar el producto en frío puede potenciar el efecto."
      },
      "OBJ013": {
        "id": "OBJ013",
        "key": "prevenir_el_envejecimiento",
        "name": "Prevenir el envejecimiento",
        "description": "Mantener una piel sana a largo plazo.",
        "priority": "Alta",
        "relatedProblems": [
          "Prevención"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "Vitamina C",
          "Retinal",
          "Péptidos",
          "Antioxidantes"
        ],
        "limitIngredients": [
          "Exposición solar sin SPF"
        ],
        "keySteps": [
          "Sérum",
          "Crema",
          "Protector Solar"
        ],
        "estimatedTime": "Continuo",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "La protección solar diaria es la clave."
      },
      "OBJ014": {
        "id": "OBJ014",
        "key": "mejorar_textura",
        "name": "Mejorar textura",
        "description": "Suavizar la superficie de la piel.",
        "priority": "Media",
        "relatedProblems": [
          "Textura irregular"
        ],
        "skinTypes": [
          "Todos"
        ],
        "recommendedIngredients": [
          "AHA",
          "BHA",
          "PHA",
          "Niacinamida"
        ],
        "limitIngredients": [
          "Exfoliación excesiva"
        ],
        "keySteps": [
          "Exfoliante",
          "Sérum"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "Alternar exfoliación química y días de descanso."
      },
      "OBJ015": {
        "id": "OBJ015",
        "key": "reducir_puntos_negros",
        "name": "Reducir puntos negros",
        "description": "Limpiar los poros y prevenir obstrucciones.",
        "priority": "Alta",
        "relatedProblems": [
          "Puntos negros"
        ],
        "skinTypes": [
          "Grasa",
          "Mixta"
        ],
        "recommendedIngredients": [
          "Ácido Salicílico",
          "Niacinamida",
          "Zinc PCA"
        ],
        "limitIngredients": [
          "Productos muy grasos"
        ],
        "keySteps": [
          "Limpieza",
          "Exfoliante BHA"
        ],
        "estimatedTime": "4-8 semanas",
        "use": {
          "am": "Sí",
          "pm": "Sí"
        },
        "notes": "No manipular manualmente los comedones."
      }
    }
  },
  "scoring": {
    "age": {
      "18_25": {
        "concerns": {
          "acne": 10,
          "sebum": 10
        }
      },
      "26_35": {
        "concerns": {
          "glow": 10,
          "hydration": 10
        }
      },
      "36_45": {
        "concerns": {
          "wrinkles": 20,
          "spots": 10
        }
      },
      "46_plus": {
        "concerns": {
          "wrinkles": 30,
          "firmness": 30
        }
      }
    },
    "skinFeel": {
      "muy_grasa": {
        "skinTypes": {
          "grasa": 100
        },
        "ingredients": {
          "niacinamida": 20,
          "zinc_pca": 20,
          "acido_salicilico": 20,
          "te_verde": 15,
          "houttuynia_cordata": 15
        }
      },
      "algo_grasa": {
        "skinTypes": {
          "mixta": 80
        },
        "ingredients": {
          "niacinamida": 15,
          "te_verde": 10,
          "centella_asiatica": 5
        }
      },
      "normal": {
        "skinTypes": {
          "normal": 100
        },
        "ingredients": {
          "acido_hialuronico": 10,
          "vitamina_c": 5
        }
      },
      "tirante": {
        "skinTypes": {
          "deshidratada": 100
        },
        "ingredients": {
          "acido_hialuronico": 20,
          "ceramidas": 20,
          "pantenol": 20,
          "betaina": 15
        }
      },
      "muy_seca": {
        "skinTypes": {
          "seca": 100
        },
        "ingredients": {
          "ceramidas": 30,
          "escualano": 25,
          "pantenol": 20,
          "beta_glucano": 20
        }
      }
    },
    "pores": {
      "muy_visibles": {
        "skinTypes": {
          "grasa": 20
        },
        "concerns": {
          "pores": 40
        },
        "ingredients": {
          "niacinamida": 15,
          "acido_salicilico": 20,
          "zinc_pca": 20
        }
      },
      "solo_nariz": {
        "skinTypes": {
          "mixta": 20
        },
        "ingredients": {
          "niacinamida": 10
        }
      },
      "apenas_visibles": {
        "skinTypes": {
          "normal": 20,
          "seca": 10
        }
      }
    },
    "concerns": {
      "acne": {
        "problemId": "PR001",
        "problemScore": 100,
        "objectiveId": "OBJ001",
        "objectiveScore": 60,
        "ingredients": {
          "niacinamida": 30,
          "zinc_pca": 25,
          "acido_salicilico": 30,
          "centella_asiatica": 15,
          "houttuynia_cordata": 20
        }
      },
      "puntos_negros": {
        "problemId": "PR002",
        "problemScore": 80,
        "objectiveId": "OBJ015",
        "objectiveScore": 60,
        "ingredients": {
          "acido_salicilico": 30,
          "niacinamida": 20,
          "zinc_pca": 15
        }
      },
      "manchas": {
        "problemId": "PR003",
        "problemScore": 100,
        "objectiveId": "OBJ005",
        "objectiveScore": 70,
        "ingredients": {
          "vitamina_c": 30,
          "acido_tranexamico": 25,
          "alfa_arbutina": 20,
          "niacinamida": 15
        }
      },
      "arrugas": {
        "problemId": "PR007",
        "problemScore": 100,
        "objectiveId": "OBJ008",
        "objectiveScore": 70,
        "ingredients": {
          "retinal": 35,
          "peptidos": 30,
          "adenosina": 25,
          "colageno_hidrolizado": 20
        }
      },
      "deshidratacion": {
        "problemId": "PR004",
        "problemScore": 100,
        "objectiveId": "OBJ003",
        "objectiveScore": 65,
        "ingredients": {
          "acido_hialuronico": 30,
          "ceramidas": 20,
          "pantenol": 20,
          "trehalosa": 15,
          "betaina": 15
        }
      },
      "descamacion": {
        "problemId": "PR005",
        "problemScore": 80,
        "objectiveId": "OBJ004",
        "objectiveScore": 70,
        "ingredients": {
          "ceramidas": 30,
          "escualano": 25,
          "pantenol": 20
        }
      },
      "flacidez": {
        "problemId": "PR008",
        "problemScore": 100,
        "objectiveId": "OBJ007",
        "objectiveScore": 70,
        "ingredients": {
          "peptidos": 30,
          "colageno_hidrolizado": 30,
          "egf": 20,
          "adenosina": 20
        }
      },
      "sensibilidad": {
        "problemId": "PR011",
        "problemScore": 100,
        "objectiveId": "OBJ004",
        "objectiveScore": 70,
        "ingredients": {
          "centella_asiatica": 30,
          "madecassoside": 25,
          "ceramidas": 20,
          "pantenol": 20,
          "beta_glucano": 15
        }
      },
      "rojeces": {
        "problemId": "PR006",
        "problemScore": 100,
        "objectiveId": "OBJ006",
        "objectiveScore": 70,
        "ingredients": {
          "centella_asiatica": 25,
          "houttuynia_cordata": 20,
          "aloe_vera": 20,
          "te_verde": 15
        }
      },
      "ninguna": {}
    },
    "goals": {
      "glow": {
        "objectiveId": "OBJ009",
        "objectiveScore": 80,
        "ingredients": {
          "vitamina_c": 30,
          "yuzu": 20,
          "extracto_de_arroz": 20,
          "galactomyces_ferment": 20,
          "papaya": 15
        }
      },
      "hidratacion": {
        "objectiveId": "OBJ003",
        "objectiveScore": 80,
        "ingredients": {
          "acido_hialuronico": 30,
          "ceramidas": 20,
          "betaina": 15,
          "pantenol": 15
        }
      },
      "antiedad_firmeza": {
        "objectiveId": "OBJ007",
        "objectiveScore": 80,
        "ingredients": {
          "retinal": 40,
          "peptidos": 30,
          "colageno_hidrolizado": 20,
          "adenosina": 20
        }
      },
      "control_grasa": {
        "objectiveId": "OBJ010",
        "objectiveScore": 80,
        "ingredients": {
          "niacinamida": 30,
          "zinc_pca": 30,
          "acido_salicilico": 20,
          "te_verde": 15
        }
      },
      "calmar": {
        "objectiveId": "OBJ006",
        "objectiveScore": 80,
        "ingredients": {
          "centella_asiatica": 30,
          "pantenol": 20,
          "ceramidas": 20,
          "houttuynia_cordata": 20
        }
      }
    },
    "routineLevels": {
      "ninguna": {
        "maxProducts": 4,
        "steps": [
          "Limpieza",
          "Serums",
          "Cremas",
          "Protector Solar"
        ]
      },
      "solo_limpiador": {
        "maxProducts": 5,
        "steps": [
          "Limpieza",
          "Tónicos",
          "Serums",
          "Cremas",
          "Protector Solar"
        ]
      },
      "basica": {
        "maxProducts": 7,
        "steps": [
          "Desmaquillantes",
          "Limpieza",
          "Tónicos",
          "Serums",
          "Contorno de ojos",
          "Cremas",
          "Protector Solar"
        ]
      },
      "completa": {
        "maxProducts": 9,
        "steps": [
          "Desmaquillantes",
          "Limpieza",
          "Exfoliantes",
          "Tónicos",
          "Mascarilla",
          "Serums",
          "Contorno de ojos",
          "Cremas",
          "Protector Solar"
        ]
      }
    },
    "productFormula": {
      "description": "Suma del score de cada ingrediente multiplicado por su peso en el producto.",
      "expression": "productScore = Σ(ingredientScore × ingredientWeight)",
      "principalMultiplier": 1.1,
      "inferredEvidenceMultiplier": 0.85,
      "minimumScore": 0
    }
  }
};

  window.SOYGlowSkinAnalyzer = window.SOYGlowSkinAnalyzer || {};
  window.SOYGlowSkinAnalyzer.data = data;

  // Compatibilidad con versiones anteriores.
  window.SOYGlowSkinAnalyzerData = data;
})(window);
